<!-- 嵌入页 -->
<style scoped>
    .swiper{
        --swiper-navigation-color: #fff;/* 单独设置按钮颜色 */
        --swiper-navigation-size: 1.8rem;/* 设置按钮大小 */
    }
    .text-red{
        color:#c90013;
    }
    .amount.active{
        animation: amount .5s ease infinite alternate;
    }
    .hover-bg-opacity-50:hover{
        --bs-bg-opacity: 0.5;
    }
    #fullPearl{
        transition: left .5s ease;
    }
    .big-scale-small{
        animation: big-scale-small .2s ease-in .2s;
    }
    @keyframes big-scale-small{
        0%{
            font-size: 4rem;
        }
        100%{
            font-size: 1.5rem;
        }
    }
    @keyframes amount {
        0% {
            box-shadow: rgb(249,252,0) 0 0 .2rem .2rem;
        }
        100% {
            box-shadow: rgba(249,252,255) 0 0 .2rem .2rem;
        }
    }
    .coruscate{
        animation: coruscate .5s ease infinite alternate;
    }
	@keyframes coruscate {
        0% {
            background: rgba(25,135,84,1);
        }
        100% {
            background: rgba(13,202,240);
        }
    }
    .scale-2{
        animation:scale2 .12s ease-out;
    }
    @keyframes scale2 {
        0% {
            transform: scale(1);
        }
        100% {
            transform: scale(1.5);
        }
    }
    .untransition{
        transition: none !important;
    }
    .monk-active::before{
        content: "";
        width:3rem;
        height:3rem;
        position: absolute;
        top: 5%;
        left: 48%;
        transform: translateX(-50%);
        border-radius: 50%;
        box-shadow: 0 0 .6rem .1rem yellow,0 0 .4rem yellow inset;
        animation: monk-circle 1.5s linear infinite alternate;
    }
    .monk-active::after{
        content: "";
        display: block;
        background: repeating-conic-gradient(rgba(0,206,255,0) 0deg, rgb(255, 255, 255) 15deg, transparent 30deg);
        mask-image: radial-gradient(rgba(0,0,0,1), rgba(255,255,255,0) 72%);
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%,-50%);
        /* animation: rays-rotate 10s linear infinite,rays-scale 1s linear infinite alternate; */
        animation: rays-rotate 20s linear infinite,monk-rays-scale 1s linear infinite alternate;
    }
    @keyframes monk-rays-scale{
		0%{
			width: 50%;
			height: 50%;
		}
		100% {
			width: 90%;
			height: 90%;
        }
	}
    .animal-active{
        transition: transform 1s cubic-bezier(.25, 1.15, .35, 3.08);
        transform:none;
    }
    .weather-active::after{
        content: "";
        display: block;
        position: absolute;
        width: 100%;
        height: 100%;
        background: url(@/assets/images/room/bac/border_style_2.png) no-repeat;
        background-size: 107rem 5.3rem;
        background-position: -0.4rem -1rem;
        z-index: 1;
        /* animation: border-style-2 2.5s steps(16) infinite; */
        animation: border-style-2 2s steps(20) infinite;
    }
    @keyframes border-style-2 {
        from{
            background-position:-0.4rem -1rem;
        }
        to{
            background-position:-107.25rem -1rem;
        }
    }
    @keyframes monk-circle {
        0% {
            box-shadow: 0 0 .6rem .1rem yellow,0 0 .4rem yellow inset;
        }
        100% {
            box-shadow: 0 0 .1rem .1rem yellow,0 0 .1rem yellow inset;
        }
    }
    .text-indent-2rem{
        text-indent: 2rem;
    }
    .get-card{
        left: 50%;
        top:50%;
        width: 5rem;
        transform:translate(-50%,-50%) rotate(0deg);
        animation: get-card-move 1s linear 1s,get-card-rotate 1s linear 1s;
    }
    .get-card.animal,.get-card.weather{
        box-shadow: 0 0 .8rem yellow;
    }
    .get-card.monk{
        width: 6rem;
    }
    .mark-ico{
        box-shadow: 0 0 .3rem #000 inset;
    }
    .mark-ico>img{
        animation: shake 1s linear infinite alternate;
    }
    @keyframes shake {
        0%{
            transform: rotateZ(-5deg);
        }
        10%{
            transform: rotateZ(5deg);
        }
        20%{
            transform: rotateZ(0deg);
        }
    }
    @keyframes get-card-move {
        0%{
            width: 5rem;
            left: 50%;
            top:50%;
        }
        70%{
            width: 5rem;
        }
        100% {
            left: 100%;
            top: 0%;
            width: 0;
        } 
    }
    @keyframes get-card-rotate {
        100% {
            transform: translate(-50%,-50%) rotate(1440deg); 
        }
    }
    @media (min-width:576px) {
        .tel-video-h{
            /* 26.917rem */
            height: 23.211rem;
        }
        .layer-absolute-sm-radius::after{
            border-radius: 1rem;
        }
        .weather-active::after{
            background-size: 148.25rem 8rem;
        }
        @keyframes border-style-2 {
            from{
                background-position:-0.4rem -1rem;
            }
            to{
                background-position:-148.45rem -1rem;
            }
        }
    }
    @media (min-width:768px) {
        .tel-video-h{
            height: 25.523rem;
        }
    }
    @media (min-width: 992px){
        .tel-video-h{
            height: 27.072rem;
        }
    }
    @media (min-width: 1200px){
        .tel-video-h{
            height: 27.194rem;
        }
    }
    @media (min-width: 1400px){
        .tel-video-h{
            height: 28.656rem;
        }
    }
</style>
<template>
    <div style="height: 64%;">
    <div class="d-flex flex-column h-100">
        <div class="d-flex flex-grow-1 h-0 flex-column" :class="[(gameModel==GAME_MODEL.normal)?(isMultiple?'flex-sm-row':'position-xs-relative start-0 end-0 top-0'):(isMultiple?'position-relative flex-sm-row':'position-relative')]">
            <!-- 经典 -->
            <div :class="{'col-sm-5 col-md-4 col-xxl-3 order-1 h-sm-100':isMultiple,'flex-grow-0 flex-sm-grow-1 h-sm-0':gameModel==GAME_MODEL.normal}" class="d-flex flex-column flex-sm-row position-relative">
                <!-- 视频区 -->
                <div class="d-flex flex-column flex-grow-1 position-relative">
                    <!-- 提交区 -->
                    <div class="position-xs-relative start-0 end-0 bottom-0 top-0" :class="{'position-sm-absolute':roomInfo.isar==1&&!isMultiple,'flex-grow-1 d-flex':isMultiple}">
                    <!-- <div class="position-xs-relative start-0 end-0 bottom-0 top-0 index-1" :class="{'position-sm-absolute':roomInfo.isar==1&&!isMultiple,'flex-grow-1 d-flex':isMultiple}"> -->
                        <!-- 背景色(因内联样式无法使用媒体查询所以这么写) -->
                        <div class="position-absolute w-100 h-100 d-sm-none" :style="{'background':roomInfo.bgcolor}"></div>
                        <!-- 操作区 -->
                        <div v-if="gameModel==GAME_MODEL.normal" class="position-xs-relative bottom-0 index-1" :class="{'perspective-600':!isMultiple,'flex-grow-1 d-flex':isMultiple,'scale-submit':isScale==true,'translate-middle-x start-50 position-sm-absolute':roomInfo.isar==1&&!isMultiple,'position-sm-relative':roomInfo.isar!=1}">
                            <div class="pb-1 pt-sm-1 pb-sm-0" :class="{'flex-grow-1 d-flex mb-sm-1 mb-md-2':isMultiple,'mb-sm-2':!isMultiple,'rotate3d-x-sm-50':roomInfo.isar==1&&!isMultiple,'me-sm-2':roomInfo.isar!=1&&!isMultiple}">
                                <div class="d-flex flex-column" :class="{'flex-grow-1':isMultiple,'flex-sm-row':!isMultiple}">
                                    <div class="d-flex flex-column flex-grow-1">
                                        <!-- 切换区1 -->
                                        <div class="d-flex justify-content-between mt-1 mb-1" :class="{'mt-sm-0':!isMultiple,'d-sm-none':roomInfo.isar!=1&&!isMultiple}">
                                            <!-- 额度统计 -->
                                            <div class="d-flex text-light flex-grow-1 justify-content-around lh-1">
                                                <div class="flex-grow-1 d-flex justify-content-around" :class="{'fs-sm-5 justify-content-sm-start align-items-center':roomInfo.isar==1&&!isMultiple}">
                                                    <span class="d-flex align-items-center">{{$t("room.ingBet")}}：{{getAmountCount("submiting",currRebate)}}</span>
                                                    <span class="d-flex align-items-center" :class="{'ms-sm-2 ms-md-3 ms-lg-4':roomInfo.isar==1&&!isMultiple}">
                                                        <span>{{$t("room.edBet")}}：</span>
                                                        <span class="d-flex align-items-center me-2 me-sm-1">
                                                            <span>{{getAmountCount("submited",REBATE_TYPE.rebate)}}</span>
                                                            <span v-if="roomInfo.iscommission==IS_REBATE.true" :class="{'w-sm-1_5rem h-sm-1_5rem':roomInfo.isar==1&&!isMultiple}" class="rounded-circle badge bg-danger rounded-circle w-1rem h-1rem d-flex justify-content-center align-items-center border border-warning ms-1">佣</span>
                                                        </span>
                                                        <span v-if="roomInfo.iscommission==IS_REBATE.true" class="d-flex align-items-center">
                                                            <span>{{getAmountCount("submited",REBATE_TYPE.noRebate)}}</span>
                                                            <span :class="{'w-sm-1_5rem h-sm-1_5rem':roomInfo.isar==1&&!isMultiple}" class="rounded-circle badge bg-success rounded-circle w-1rem h-1rem d-flex justify-content-center align-items-center border border-warning ms-1">免</span>
                                                        </span>
                                                    </span>
                                                    <span class="d-flex align-items-center" :class="{'ms-sm-2 ms-md-3 ms-lg-4':roomInfo.isar==1&&!isMultiple}">{{$t("room.allBet")}}：{{getAmountCount("submited",REBATE_TYPE.rebate)+getAmountCount("submited",REBATE_TYPE.noRebate)+getAmountCount("submiting")}}</span>
                                                </div>
                                                <i @click="isShowPokerLayer=true" class="d-flex d-sm-none bi bi-suit-spade me-2"></i>
                                            </div>
                                            <!-- 免佣 -->
                                            <div v-if="roomInfo.isar==1&&!isMultiple" class="d-none d-sm-flex">
                                                <div class="form-check form-switch d-flex align-items-center border border-1 border-secondary rounded p-1 mb-0 me-sm-1 me-md-2">
                                                    <label class="me-1 text-light" for="cboRebateNew">{{$t("room.unRebate")}}</label>
                                                    <input class="form-check-input fs-3 m-0" type="checkbox" id="cboRebateNew" @change="setRebate($event)" :checked="currRebate==REBATE_TYPE.noRebate">
                                                </div>
                                            </div>
                                        </div>
        
                                        <div class="d-flex flex-grow-1 flex-column-reverse" :class="{'flex-sm-row':roomInfo.isar==1&&!isMultiple,'flex-row':roomInfo.isar!=1,'flex-sm-row-reverse':roomInfo.isar!=1&&!isMultiple}">
                                            <div :class="{'flex-sm-row ps-sm-1 pe-sm-2':roomInfo.isar!=1&&!isMultiple,'flex-sm-column-reverse':roomInfo.isar==1&&isMultiple}" class="d-flex flex-column px-1 px-sm-0">
                                                <!-- 选筹区 -->
                                                <div class="d-flex justify-content-between justify-content-sm-around text-black order-2 order-sm-1 mb-2 mb-sm-0 flex-grow-1" :class="{'py-sm-1 py-md-2 py-lg-3':isMultiple,'flex-sm-column':!isMultiple,'col':roomInfo.isar!=1}">
                                                    
                                                    <div v-for="(item,i) in currAmountList" :key="i" class="d-flex justify-content-around align-items-center col" :class="{'col-sm-auto justify-content-sm-start':roomInfo.isar==1&&!isMultiple}">
                                                        <div v-for="j in 2" class="position-relative me-1 chips rounded-circle" :class="{active:amount==item[j-1]}" @click="amount=item[j-1]" role="button">
                                                            <button v-if="i==2&&j==2" @click.stop="isShowMoreAmount=!isShowMoreAmount" class="btn btn-secondary btn-shadow-left text-light">
                                                                <i class="bi bi-grid-fill"></i>
                                                            </button>
                                                            <chip v-else :foot-class="['bg-'+item[j-1],(roomInfo.isar==1&&!isMultiple)?'ms-sm-_1rem':'']" :face-class="['bg-'+item[j-1]]" :chip-text="$root.chipsTxtConvert(item[j-1])"></chip>
                                                        </div>
                                                    </div>
                                                    
                                                </div>
                                            </div>
                                            <!-- 下单区 -->
                                            <div :class="{'flex-column':roomInfo.isar!=1&&!isMultiple}" class="flex-grow-1 d-flex align-items-sm-stretch position-relative order-1 order-sm-2 text-center mb-2 mb-sm-0">
                                                <!-- 切换区2 -->
                                                <div v-if="roomInfo.isar!=1&&!isMultiple" class="d-none d-sm-flex justify-content-between mt-1 mb-1 small" :class="{'mt-sm-0':!isMultiple}">
                                                    <!-- 额度统计 -->
                                                    <div class="d-flex text-light flex-grow-1 lh-1 ms-2">
                                                        <div class="flex-grow-1 d-flex" :class="{'fs-sm-5 justify-content-sm-start align-items-center':roomInfo.isar==1&&!isMultiple}">
                                                            <span class="d-flex align-items-center">{{$t("room.ingBet")}}：{{getAmountCount("submiting",currRebate)}}</span>
                                                            <span class="d-flex align-items-center" :class="{'ms-sm-2 ms-md-3 ms-lg-4':!isMultiple}">
                                                                <span>{{$t("room.edBet")}}：</span>
                                                                <span class="d-flex align-items-center me-2 me-sm-1">
                                                                    <span>{{getAmountCount("submited",REBATE_TYPE.rebate)}}</span>
                                                                    <span v-if="roomInfo.iscommission==IS_REBATE.true" :class="{'w-sm-1_5rem h-sm-1_5rem':roomInfo.isar==1&&!isMultiple}" class="rounded-circle badge bg-danger rounded-circle w-1rem h-1rem d-flex justify-content-center align-items-center border border-warning ms-1">佣</span>
                                                                </span>
                                                                <span v-if="roomInfo.iscommission==IS_REBATE.true" class="d-flex align-items-center">
                                                                    <span>{{getAmountCount("submited",REBATE_TYPE.noRebate)}}</span>
                                                                    <span :class="{'w-sm-1_5rem h-sm-1_5rem':roomInfo.isar==1&&!isMultiple}" class="rounded-circle badge bg-success rounded-circle w-1rem h-1rem d-flex justify-content-center align-items-center border border-warning ms-1">免</span>
                                                                </span>
                                                            </span>
                                                            <span class="d-flex align-items-center" :class="{'ms-sm-2 ms-md-3 ms-lg-4':!isMultiple}">{{$t("room.allBet")}}：{{getAmountCount("submited",REBATE_TYPE.rebate)+getAmountCount("submited",REBATE_TYPE.noRebate)+getAmountCount("submiting")}}</span>
                                                        </div>
                                                        <i @click="isShowPokerLayer=true" class="d-flex d-sm-none bi bi-suit-spade me-2"></i>
                                                    </div>
                                                    <!-- 免佣 -->
                                                    <div class="d-none d-sm-flex">
                                                        <div class="form-switch d-flex align-items-center mb-0 me-sm-1 me-md-2">
                                                            <label class="me-1 text-light" for="cboRebateNew">{{$t("room.unRebate")}}</label>
                                                            <input class="form-check-input fs-5 m-0" type="checkbox" id="cboRebateNew" @change="setRebate($event)" :checked="currRebate==REBATE_TYPE.noRebate">
                                                        </div>
                                                    </div>
                                                </div>
                                                <div :class="{'flex-grow-1':!isMultiple,'flex-grow-1 align-items-sm-stretch':isMultiple,'flex-sm-nowrap':!isMultiple}" class="d-flex flex-wrap align-items-sm-end align-items-lg-stretch position-relative order-1 order-sm-2 text-center">
                                                    <!-- xd -->
                                                    <div v-if="roomInfo.game==GAME_ID.bac" class="d-flex col-4 flex-column justify-content-between border-solid border-xs border-end-xs-0 border-bottom-xs-0 border-light position-relative flex-grow-1 overflow-hidden" :class="{'col-sm-auto order-sm-1 me-sm-1 me-md-2 me-lg-3 ms-sm-1 ms-md-2 rounded-sm-10 border-sm-2 border-md-3 border-lg-4 layer-absolute-sm-radius':!isMultiple,'border border-end-0 border-bottom-0 bg-success':isMultiple,'coruscate':coruscateArr.indexOf('xd')!=-1,'layer-absolute':odds.xd==0}" @click="addAmount('xd',$event)">
                                                        <!-- 池额 -->
                                                        <div v-show="pool.xd>0" class="position-absolute w-100 bottom-0 index-_1 text-start small text-shadow-white fw-bold" :style="{background:'rgb(0, 71, 133,.5)',height: pool.xd/(Number(pool.z)+Number(pool.x)+Number(pool.h)+Number(pool.zd)+Number(pool.xd))*100+'%'}">
                                                            <span class="position-absolute top-0 translate-end-y index-1">{{pool.xd}}</span>
                                                        </div>
                                                        <!-- 文字 -->
                                                        <span class="fs-2 fw-bold flex-grow-1 d-flex justify-content-center flex-column text-nowrap text-shadow-white" :class="[isMultiple?'my-sm-0 my-lg-1 lh-sm-1':'mx-sm-3 mx-md-4']" :style="{'color':COLOR.blueDark}">{{$t("common.xd")}}</span>
                                                        <!-- 信息 -->
                                                        <div class="small text-white-50 text-nowrap" :class="[isMultiple?'lh-sm-1 lh-xl-2':'']">
                                                            <div>{{limitred.xd}}</div>
                                                            <div>1:{{odds.xd}}</div>
                                                        </div>
                                                        <!-- 单额 -->
                                                        <div :class="{'chip-pulse':submiting.xd>0}" class="position-absolute start-50 me-5 me-sm-4 top-55 w-0 h-0">
                                                            <div v-for="j,index in chipsConvert(submited[currRebate].xd+submiting.xd)" :key="j" :style="'bottom:'+(0.2*index)+'rem !important'" class="position-absolute translate-middle-x fs-6 text-black" :class="{'chips-img-shadow':index==0}">
                                                                <chip :foot-class="['bg-'+j,(roomInfo.isar==1&&!isMultiple)?'ms-sm-_1rem':'']" :face-class="['bg-'+j]" :chip-text="$root.chipsTxtConvert(j)"></chip>
                                                                <span class="position-absolute start-50 top-50 fw-bold chips-text small">{{$root.chipsTxtConvert(j)}}</span>
                                                            </div>
                                                            <div class="position-absolute translate-middle-x text-black fw-bold fs-6 top-0 mt-2">
                                                                <span class="d-block small scale" :class="{'scale-2':isScaleAmount.xd}">
                                                                    <small class="text-shadow-white">{{submited[currRebate].xd+submiting.xd>0?submited[currRebate].xd+submiting.xd:''}}</small>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <!-- h -->
                                                    <div class="d-flex col-4 flex-column justify-content-between border-solid border-xs border-end-xs-0 border-light position-relative flex-grow-1" :class="{'col-sm-auto mx-sm-1 mx-md-2 mx-lg-3 rounded-sm-10 border-sm-2 border-md-3 border-lg-4 layer-absolute-sm-radius':!isMultiple,'border border-end-0 bg-success':isMultiple,'border-bottom-0':roomInfo.game==GAME_ID.bac&&isMultiple,'coruscate':coruscateArr.indexOf('h')!=-1,'order-sm-3':roomInfo.game==GAME_ID.bac&&!isMultiple,'order-2':roomInfo.game!=GAME_ID.bac,'border-bottom-xs-0':roomInfo.game==GAME_ID.bac,'layer-absolute':odds.h==0}" @click="addAmount('h',$event)">
                                                        <!-- 池额 -->
                                                        <div v-show="pool.h>0" class="position-absolute w-100 bottom-0 index-_1 text-start small text-shadow-white fw-bold" :style="{background:'rgb(0, 170, 0,.5)',height: pool.h/(Number(pool.z)+Number(pool.x)+Number(pool.h)+Number(pool.zd)+Number(pool.xd))*100+'%',color:COLOR.green}">
                                                            <span class="position-absolute top-0 translate-end-y index-1">{{ pool.h }}</span>
                                                        </div>
                                                        <!-- 文字 -->
                                                        <span class="fw-bold flex-grow-1 d-flex justify-content-center flex-column text-shadow-white" :class="[roomInfo.game==GAME_ID.lh?'fs-xs-2 fs-sm-2 lh-2-4 my-2 my-sm-0 lh-4 lh-sm-base border-sm-0':'',isMultiple?(roomInfo.game==GAME_ID.lh?'fs-xs-2 h1-sm lh-2-4 my-2 my-sm-0 my-lg-2':'fs-2 my-sm-0 my-lg-1 lh-sm-1'):(roomInfo.game==GAME_ID.lh?'mx-sm-5 mx-md-4 px-sm-3 px-md-5':'fs-2 mx-sm-4 mx-lg-5 px-sm-2 px-md-3 px-lg-0')]" :style="'color:'+COLOR.green">{{$t("common.h")}}</span>
                                                        <!-- 信息 -->
                                                        <div class="small text-white-50 text-nowrap">
                                                            <div :class="[roomInfo.game==GAME_ID.lh?'lh-xs-3':'',isMultiple?(roomInfo.game==GAME_ID.lh?'lh-xs-3 lh-sm-2 lh-xl-4':'lh-sm-1 lh-xl-2'):(roomInfo.game==GAME_ID.lh?'':'')]">{{limitred.h}}</div>
                                                            <div :class="[roomInfo.game==GAME_ID.lh?'lh-xs-3':'',isMultiple?(roomInfo.game==GAME_ID.lh?'lh-xs-3 lh-sm-2 lh-xl-4':'lh-sm-1 lh-xl-2'):(roomInfo.game==GAME_ID.lh?'':'')]">1:{{odds.h}}</div>
                                                        </div>
                                                        <!-- 单额 -->
                                                        <div :class="{'chip-pulse':submiting.h>0}" class="position-absolute start-50 me-5 me-sm-4 top-55 w-0 h-0">
                                                            <div v-for="j,index in chipsConvert(submited[currRebate].h+submiting.h)" :key="j" :style="'bottom:'+(0.2*index)+'rem !important'" class="position-absolute fs-6 text-black translate-middle-x" :class="{'chips-img-shadow':index==0}">
                                                                <chip :foot-class="['bg-'+j,(roomInfo.isar==1&&!isMultiple)?'ms-sm-_1rem':'']" :face-class="['bg-'+j]" :chip-text="$root.chipsTxtConvert(j)"></chip>
                                                                <span class="position-absolute start-50 top-50 fw-bold chips-text small">{{$root.chipsTxtConvert(j)}}</span>
                                                            </div>
                                                            <div class="position-absolute translate-middle-x text-black fw-bold fs-6 top-0 mt-2">
                                                                <span class="d-block small scale" :class="{'scale-2':isScaleAmount.h}">
                                                                    <small class="d-block text-shadow-white">{{submited[currRebate].h+submiting.h>0?submited[currRebate].h+submiting.h:''}}</small>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <!-- zd -->
                                                    <div v-if="roomInfo.game==GAME_ID.bac" class="d-flex col-4 flex-column justify-content-between border-solid border-xs border-bottom-xs-0 border-light position-relative flex-grow-1" :class="{'col-sm-auto order-sm-5 ms-sm-1 ms-md-2 ms-lg-3 me-sm-1 me-md-2 rounded-sm-10 border-sm-2 border-md-3 border-lg-4 layer-absolute-sm-radius':!isMultiple,'border border-bottom-0 bg-success':isMultiple,'coruscate':coruscateArr.indexOf('zd')!=-1,'layer-absolute':odds.zd==0}" @click="addAmount('zd',$event)">
                                                        <!-- 池额 -->
                                                        <div v-show="pool.zd>0" class="position-absolute w-100 bottom-0 index-_1 text-start small text-shadow-white fw-bold" :style="{background:'rgb(255, 0, 0,.5)',height: pool.zd/(Number(pool.z)+Number(pool.x)+Number(pool.h)+Number(pool.zd)+Number(pool.xd))*100+'%',color:COLOR.redDark}">
                                                            <span class="position-absolute top-0 translate-end-y index-1">{{ pool.zd }}</span>
                                                        </div>
                                                        <!-- 文字 -->
                                                        <span class="fs-2 fw-bold flex-grow-1 d-flex justify-content-center flex-column text-nowrap text-shadow-white" :class="[isMultiple?'my-sm-0 my-lg-1 lh-sm-1':'mx-sm-3 mx-md-4']" :style="'color:'+COLOR.redDark">{{$t("common.zd")}}</span>
                                                        <!-- 信息 -->
                                                        <div class="small text-white-50 text-nowrap" :class="[isMultiple?'lh-sm-1 lh-xl-2':'']">
                                                            <div>{{limitred.zd}}</div>
                                                            <div>1:{{odds.zd}}</div>
                                                        </div>
                                                        <!-- 单额 -->
                                                        <div :class="{'chip-pulse':submiting.zd>0}" class="position-absolute start-50 me-5 me-sm-4 top-55 w-0 h-0">
                                                            <div v-for="j,index in chipsConvert(submited[currRebate].zd+submiting.zd)" :key="j" :style="'bottom:'+(0.2*index)+'rem !important'" class="position-absolute translate-middle-x fs-6 text-black" :class="{'chips-img-shadow':index==0}">
                                                                <chip :foot-class="['bg-'+j,(roomInfo.isar==1&&!isMultiple)?'ms-sm-_1rem':'']" :face-class="['bg-'+j]" :chip-text="$root.chipsTxtConvert(j)"></chip>
                                                                <span class="position-absolute start-50 top-50 fw-bold chips-text small">{{$root.chipsTxtConvert(j)}}</span>
                                                            </div>
                                                            <div class="position-absolute translate-middle-x text-black fw-bold fs-6 top-0 mt-2">
                                                                <span class="d-block small scale" :class="{'scale-2':isScaleAmount.zd}">
                                                                    <small class="d-block text-shadow-white">{{submited[currRebate].zd+submiting.zd>0?submited[currRebate].zd+submiting.zd:''}}</small>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <!-- x -->
                                                    <div class="d-flex flex-column justify-content-between border-solid border-xs border-light position-relative flex-grow-1" :class="{'col-sm-auto rounded-sm-10 border-sm-2 border-md-3 border-lg-4 layer-absolute-sm-radius':!isMultiple,'border-1 bg-success':isMultiple,'coruscate':coruscateArr.indexOf('x')!=-1,'order-sm-2 col-6 border-end-xs-0':roomInfo.game==GAME_ID.bac,'border-end-0':roomInfo.game==GAME_ID.bac&&isMultiple,'col-4 order-3':roomInfo.game!=GAME_ID.bac,'me-sm-2':roomInfo.game!=GAME_ID.bac&&!isMultiple,'layer-absolute':odds.x==0}" @click="addAmount('x',$event)">
                                                        <!-- 池额 -->
                                                        <div v-show="pool.x>0" class="position-absolute w-100 bottom-0 index-_1 text-start small text-shadow-white fw-bold" :style="{background:'rgb(0, 105, 197,.5)',height: (pool.x/(Number(pool.z)+Number(pool.x)+Number(pool.h)+Number(pool.zd)+Number(pool.xd))*100).toFixed(2)+'%',color:COLOR.blue}">
                                                            <span class="position-absolute top-0 translate-end-y index-1">{{ pool.x }}</span>
                                                        </div>
                                                        <!-- 文字 -->
                                                        <span class="fw-bold flex-grow-1 d-flex justify-content-center flex-column text-shadow-white" :class="[roomInfo.game==GAME_ID.lh?'fs-xs-2 fs-sm-2 lh-2-4 my-2 my-sm-0 fs-2 lh-4 lh-sm-base border-sm-0':'',isMultiple?(roomInfo.game==GAME_ID.lh?'fs-xs-2 h1-sm lh-2-4 my-2 my-sm-0 my-lg-2':'fs-2 my-sm-0 my-lg-1 lh-sm-1'):(roomInfo.game==GAME_ID.lh?'mx-sm-5 mx-md-4 px-sm-3 px-md-5':'fs-2 mx-sm-4 mx-lg-5 px-sm-2 px-md-3 px-lg-0')]" :style="'color:'+COLOR.blue">{{$root.getTextByGame("common.",roomInfo.game,1)}}</span>
                                                        <!-- 信息 -->
                                                        <div class="small text-white-50 text-nowrap">
                                                            <div :class="[roomInfo.game==GAME_ID.lh?'lh-xs-3':'',isMultiple?(roomInfo.game==GAME_ID.lh?'lh-xs-3 lh-sm-2 lh-xl-4':'lh-sm-1 lh-xl-2'):(roomInfo.game==GAME_ID.lh?'':'')]">{{limitred.x}}</div>
                                                            <div :class="[roomInfo.game==GAME_ID.lh?'lh-xs-3':'',isMultiple?(roomInfo.game==GAME_ID.lh?'lh-xs-3 lh-sm-2 lh-xl-4':'lh-sm-1 lh-xl-2'):(roomInfo.game==GAME_ID.lh?'':'')]">1:{{currRebate==REBATE_TYPE.rebate?odds.x:1}}</div>
                                                        </div>
                                                        <!-- 单额 -->
                                                        <div :class="{'chip-pulse':submiting.x>0}" class="position-absolute start-50 me-5 me-sm-4 top-55 w-0 h-0">
                                                            <div v-for="j,index in chipsConvert(submited[currRebate].x+submiting.x)" :key="j" :style="'bottom:'+(0.2*index)+'rem !important'" class="position-absolute fs-6 text-black translate-middle-x" :class="{'chips-img-shadow':index==0}">
                                                                <chip :foot-class="['bg-'+j,(roomInfo.isar==1&&!isMultiple)?'ms-sm-_1rem':'']" :face-class="['bg-'+j]" :chip-text="$root.chipsTxtConvert(j)"></chip>
                                                                <span class="position-absolute start-50 top-50 fw-bold chips-text small">{{$root.chipsTxtConvert(j)}}</span>
                                                            </div>
                                                            <div class="position-absolute translate-middle-x text-black fw-bold fs-6 top-0 mt-2">
                                                                <span class="d-block small scale" :class="{'scale-2':isScaleAmount.x}">
                                                                    <small class="d-block text-shadow-white">{{submited[currRebate].x+submiting.x>0?submited[currRebate].x+submiting.x:''}}</small>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <!-- z -->
                                                    <div class="d-flex flex-column justify-content-between border-solid border-xs border-light position-relative flex-grow-1" :class="{'col-sm-auto rounded-sm-10 border-sm-2 border-md-3 border-lg-4 layer-absolute-sm-radius':!isMultiple,'border-1 bg-success':isMultiple,'coruscate':coruscateArr.indexOf('z')!=-1,'order-sm-4 col-6':roomInfo.game==GAME_ID.bac,'col-4 order-1 border-end-xs-0':roomInfo.game!=GAME_ID.bac,'border-end-0':roomInfo.game!=GAME_ID.bac&&isMultiple,'ms-sm-2':roomInfo.game!=GAME_ID.bac&&!isMultiple,'layer-absolute':odds.z==0}" @click="addAmount('z',$event)">
                                                        <!-- 池额 -->
                                                        <div v-show="pool.z>0" class="position-absolute w-100 bottom-0 index-_1 text-start small text-shadow-white fw-bold" :style="{background:'rgb(255, 40, 40,.5)',height: (pool.z/(Number(pool.z)+Number(pool.x)+Number(pool.h)+Number(pool.zd)+Number(pool.xd))*100).toFixed(2)+'%',color:COLOR.red}">
                                                            <span class="position-absolute top-0 translate-end-y index-1">{{ pool.z }}</span>
                                                        </div>
                                                        <!-- 文字 -->
                                                        <span class="fw-bold flex-grow-1 d-flex justify-content-center flex-column text-shadow-white" :class="[roomInfo.game==GAME_ID.lh?'fs-xs-2 fs-sm-2 lh-2-4 my-2 my-sm-0 fs-2 lh-4 lh-sm-base border-sm-0':'',isMultiple?(roomInfo.game==GAME_ID.lh?'fs-xs-2 h1-sm lh-2-4 my-2 my-sm-0 my-lg-2':'fs-2 my-sm-0 my-lg-1 lh-sm-1'):(roomInfo.game==GAME_ID.lh?'mx-sm-5 mx-md-4 px-sm-3 px-md-5':'fs-2 mx-sm-4 mx-lg-5 px-sm-2 px-md-3 px-lg-0')]" :style="'color:'+COLOR.red">{{$root.getTextByGame("common.",roomInfo.game,0)}}</span>
                                                        <!-- 信息 -->
                                                        <div class="small text-white-50 text-nowrap">
                                                            <div :class="[roomInfo.game==GAME_ID.lh?'lh-xs-3':'',isMultiple?(roomInfo.game==GAME_ID.lh?'lh-xs-3 lh-sm-2 lh-xl-4':'lh-sm-1 lh-xl-2'):(roomInfo.game==GAME_ID.lh?'':'')]">{{limitred.z}}</div>
                                                            <div :class="[roomInfo.game==GAME_ID.lh?'lh-xs-3':'',isMultiple?(roomInfo.game==GAME_ID.lh?'lh-xs-3 lh-sm-2 lh-xl-4':'lh-sm-1 lh-xl-2'):(roomInfo.game==GAME_ID.lh?'':'')]">1:{{currRebate==REBATE_TYPE.rebate?odds.z:1+(roomInfo.game==GAME_ID.bac?'('+$t("room.rebateTxt")+')':'')}}</div>
                                                        </div>
                                                        <!-- 单额 -->
                                                        <div :class="{'chip-pulse':submiting.z>0}" class="position-absolute start-50 me-5 me-sm-4 top-55 w-0 h-0">
                                                            <div v-for="j,index in chipsConvert(submited[currRebate].z+submiting.z)" :key="j" :style="'bottom:'+(0.2*index)+'rem !important'" class="position-absolute translate-middle-x fs-6 text-black" :class="{'chips-img-shadow':index==0}">
                                                                <chip :foot-class="['bg-'+j,(roomInfo.isar==1&&!isMultiple)?'ms-sm-_1rem':'']" :face-class="['bg-'+j]" :chip-text="$root.chipsTxtConvert(j)"></chip>
                                                                <span class="position-absolute start-50 top-50 fw-bold chips-text small">{{$root.chipsTxtConvert(j)}}</span>
                                                            </div>
                                                            <div class="position-absolute translate-middle-x text-black fw-bold fs-6 top-0 mt-2">
                                                                <span class="d-block small scale" :class="{'scale-2':isScaleAmount.z}">
                                                                    <small class="d-block text-shadow-white">{{submited[currRebate].z+submiting.z>0?submited[currRebate].z+submiting.z:''}}</small>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <!-- 更多筹区 -->
                                                    <change-amount :class="{'rounded-sm-10':!isMultiple}" :is-show="isShowMoreAmount"></change-amount>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- 按钮区 -->
                                    <div class="d-flex justify-content-between text-nowrap order-3 mb-1 mb-sm-0 px-1" :class="{'ps-sm-0 pe-sm-2':isMultiple,'justify-content-sm-around px-sm-0 ms-sm-1 flex-sm-column':!isMultiple}">
                                        <label class="text-warning fw-bold fs-1 lh-1 d-flex align-items-center justify-content-end" style="min-width: 2.5rem;">{{ roomInfo.countdown }}</label>
                                        <div :class="{'d-sm-none':!isMultiple}" class="form-check form-switch d-flex align-items-center border border-1 border-secondary rounded p-1 mb-0">
                                            <label class="me-1 text-light" for="cboRebateNewXs">{{$t("room.unRebate")}}</label>
                                            <input class="form-check-input fs-3 m-0" type="checkbox" id="cboRebateNewXs" @change="setRebate($event)" :checked="currRebate==REBATE_TYPE.noRebate">
                                        </div>
                                        <!-- <button class="btn btn-primary bg-gradient text-light btn-shadow-right-primary" :class="{'mb-sm-1':roomInfo.isar==1&&!isMultiple}" type="button" @click="submitEvent('multiple')">{{isMultiple?$t("room.singleRoom"):$t("room.multipleRoom")}}</button> -->
                                        <button class="btn bg-gradient text-light opacity-100" :class="{'disabled btn-secondary':!canClear,'btn-shadow-right-secondary':roomInfo.isar==1&&!canClear,'btn-shadow-right-secondary-mini':(roomInfo.isar!=1&&!canClear)||isMultiple,'btn-warning':canClear,'btn-shadow-right-warning':roomInfo.isar==1&&canClear,'btn-shadow-right-warning-mini':roomInfo.isar!=1&&canClear,'mb-sm-1':roomInfo.isar==1&&!isMultiple,'mb-sm-2':roomInfo.isar!=1&&!isMultiple}" :disabled="!canClear" @click="submitEvent('clear')">{{$t("room.clear")}}</button>
                                        <button class="btn bg-gradient text-light opacity-100" :class="{'disabled btn-secondary':!canCancel,'btn-shadow-right-secondary':roomInfo.isar==1&&!canCancel,'btn-shadow-right-secondary-mini':(roomInfo.isar!=1&&!canCancel)||isMultiple,'btn-danger':canCancel,'btn-shadow-right-danger':roomInfo.isar==1&&canCancel,'btn-shadow-right-danger-mini':roomInfo.isar!=1&&canCancel,'mb-sm-1':roomInfo.isar==1&&!isMultiple,'mb-sm-2':roomInfo.isar!=1&&!isMultiple}" :disabled="!canCancel" @click="submitEvent('cancel')">{{$t("room.cancel")}}</button>
                                        <button class="btn bg-gradient text-light opacity-100" :class="{'disabled btn-secondary':!canConfirm,'btn-shadow-right-secondary':roomInfo.isar==1&&!canConfirm,'btn-shadow-right-secondary-mini':(roomInfo.isar!=1&&!canConfirm)||isMultiple,'btn-success':canConfirm,'btn-shadow-right-success':roomInfo.isar==1&&canConfirm,'btn-shadow-right-success-mini':roomInfo.isar!=1&&canConfirm}" :disabled="!canConfirm" @click="submitEvent('confirm')">{{$t("room.confirm")}}</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- 牌区 -->
                        <div v-if="showPokerArr.length>0" :class="[isShowPokerLayer?'d-flex':'d-none d-sm-flex',isMultiple?'top-sm-6rem transform-left-center scale-sm-_8 ms-sm-1':'top-sm-26 ms-sm-2']" class="position-absolute top-xs-0 index-1 w-xs-100 h-xs-100 align-items-center align-items-sm-start justify-content-center justify-content-sm-start bg-xs-dark bg-opacity-75 rounded-sm-10 text-start">
                            <div v-for="(item,i) in showPokerArr" :key="item" :class="[roomInfo.game==GAME_ID.bac?'order-'+(showPokerArr.length-i):'']" :style="{'background':(i==0?'linear-gradient('+(roomInfo.game==GAME_ID.bac?90:270)+'deg,#910000, rgb(251, 36, 1) 40%)':'linear-gradient('+(roomInfo.game==GAME_ID.bac?270:90)+'deg,#00315d,rgb(0, 105, 197) 40%)')}" class="d-flex flex-column rounded">
                                <div :class="[isMultiple?'pt-1 pt-sm-0 small-sm':'pt-1']" class="text-light text-center fw-bold rounded position-relative fs-xs-5">
                                    <span>{{roomInfo.game==GAME_ID.bac?i==0?$t("common.z"):$t("common.x"):i==0?$t("common.l"):$t("common.hu")}}</span>
                                    <i class="position-absolute fw-bold fs-xs-1 fs-sm-4 lh-1" :class="{'end-0':(roomInfo.game==GAME_ID.bac&&i!=0)||(roomInfo.game!=GAME_ID.bac&&i==0),'start-0':(roomInfo.game==GAME_ID.bac&&i==0||roomInfo.game!=GAME_ID.bac&&i!=0)}" :style="{'color':i==0?COLOR.red:COLOR.blue}">{{ roomInfo.game==GAME_ID.bac?(i==0?'S':'V'):(i==0?'V':'S') }}</i>
                                    <span v-if="isPokerWin(i)&&isShowPokerCompare" class="bi bi-trophy-fill text-yellow position-absolute translate-middle-y top-50 big-scale-small fs-xs-1 fs-sm-4" :class="{'start-0':(roomInfo.game==GAME_ID.bac&&i!=0)||(roomInfo.game!=GAME_ID.bac&&i==0),'end-0':(roomInfo.game==GAME_ID.bac&&i==0||roomInfo.game!=GAME_ID.bac&&i!=0)}"></span>
                                </div>
                                <div :class="[isMultiple?'w-sm-5rem h-sm-6rem':'w-sm-7rem h-sm-8rem']" class="rounded p-1 d-flex flex-wrap justify-content-between align-items-end position-relative w-10rem h-11rem">
                                    <!-- 牌 -->
                                    <div v-for="(val,j) in item" :key="val" class="d-flex align-items-center justify-content-center" :class="[item.length==3&&j==2?'w-100 order-1':'order-2']">
                                        <div v-if="val" :class="[$root.getPokerByNum(val)['color'],((i+1)==currPokerXY[0]&&(j+1)==currPokerXY[1])?'rotate':'',j==2?'':'flex-column',isMultiple?'small-sm p-xs-1 p-sm-_125rem':'p-1']" class="d-flex bg-light rounded ">
                                            <span class="fw-bold lh-1 fs-xs-5 small" :class="{'order-1 text-vertical':j==2}">{{ $root.getPokerByNum(val)["name"] }}</span>
                                            <div class="d-flex flex-grow-1" :class="[j==2?'py-3 py-sm-2 pe-2 pe-sm-1 ps-3 ps-sm-2':'px-3 px-sm-2 pt-2 pt-sm-1 pb-3 pb-sm-2']">
                                                <i :class="[$root.getPokerByNum(val)['shape'],j==2?'rotate-90':'',isMultiple?'':'fs-sm-4']" class="bi d-flex align-items-center justify-content-center fs-xs-2 flex-grow-1"></i>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="isShowPokerCompare" class="position-absolute top-50 start-50 translate-middle init-rotate-345 border-double border-dark px-1 rounded fw-bold text-nowrap big-scale-small">{{ getPoint(item) }}点</div>
                                </div>
                            </div>
                            <div class="d-sm-none position-absolute top-0 end-0 pt-2 pe-2">
                                <i @click="isShowPokerLayer=false" class="d-flex bi bi-x-octagon text-light fs-3"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 路单统计区 -->
            <div v-if="!isMultiple" class="d-flex flex-wrap justify-content-between text-light pe-2 small bg-gradient">
                <div class="ps-2">{{$root.getTextByGame("common.",roomInfo.game,0)}}：{{pearlCount.z}}</div>
                <div class="ps-2">{{$root.getTextByGame("common.",roomInfo.game,1)}}：{{pearlCount.x}}</div>
                <div class="ps-2">{{$t("common.h")}}：{{pearlCount.h}}</div>
                <div class="ps-2" v-if="roomInfo.game==GAME_ID.bac">{{$t("common.zd")}}：{{pearlCount.zd}}</div>
                <div class="ps-2" v-if="roomInfo.game==GAME_ID.bac">{{$t("common.xd")}}：{{pearlCount.xd}}</div>
                <div class="d-flex col-12 col-sm-auto fw-bold">
                    <div class="ps-2 col-6 col-sm-auto d-flex">
                        <span class="text-danger">{{$root.getTextByGame("room.next",roomInfo.game,0)}}：</span>
                        <label class="d-flex align-items-center text-transparent">
                            <span class="rounded-circle w-1rem h-1rem border-2 border-solid me-2" :style="nextZHollowStyle"></span>
                            <span class="h-1rem border-1 border-top-0 border-left-0 border-bottom-0 rotate-30 border-solid me-2" :style="nextZBevelStyle"></span>
                            <span class="rounded-circle w-1rem h-1rem border-3" :style="nextZSolidStyle"></span>
                        </label>
                    </div>
                    <div class="ps-2 col-6 col-sm-auto d-flex justify-content-end">
                        <span :style="'color:'+COLOR.blue">{{$root.getTextByGame("room.next",roomInfo.game,1)}}：</span>
                        <label class="d-flex align-items-center text-transparent">
                            <span class="rounded-circle w-1rem h-1rem border-2 border-solid me-2" :style="nextXHollowStyle"></span>
                            <span class="h-1rem border-1 border-top-0 border-left-0 border-bottom-0 rotate-30 border-solid me-2" :style="nextXBevelStyle"></span>
                            <span class="rounded-circle w-1rem h-1rem border-3" :style="nextXSolidStyle"></span>
                        </label>
                    </div>
                </div>
            </div>
            <!-- 路单区 -->
            <div v-if="!isMultiple" class="flex-grow-1 d-flex h-0 position-relative" :class="[(gameModel==GAME_MODEL.normal)?'flex-sm-grow-0 h-sm-6rem':'overflow-hidden']">
                <!-- 问路 -->
                <div class="d-flex flex-column text-light text-center w-2rem text-nowrap small">
                    <div @click="nextPrediction(roomInfo.game==GAME_ID.bac?'A':'M')" :style="'background:'+COLOR.red+';border-color:'+COLOR.red" class="d-flex justify-content-center align-items-center col text-vertical small bg-highlight border-_3 border-style-outset" role="button">{{$root.getTextByGame("room.will",roomInfo.game,0)}}</div>
                    <div @click="nextPrediction(roomInfo.game==GAME_ID.bac?'B':'N')" :style="'background:'+COLOR.blue+';border-color:'+COLOR.blue" class="d-flex justify-content-center align-items-center col text-vertical small bg-highlight border-_3 border-style-outset" role="button">{{$root.getTextByGame("room.will",roomInfo.game,1)}}</div>
                </div>
                <!-- 路单 -->
                <div :class="{'flex-sm-nowrap':pearlModel==1,'flex-column':pearlModel==2}" class="flex-grow-1 d-flex flex-wrap w-0">
                    <div :class="{'col-6 col-sm-3 h-xs-50 h-sm-100':pearlModel==1,'h-xs-33 col-sm-3 h-sm-100':pearlModel==2}" class="position-relative">
                        <canvas id="textBigPearl" class="bg-light d-block mx-auto min-w-100 min-h-100 mw-100 mh-100" v-set-size="6" data-canvas-room="6" width="0" height="0" @mousemove.stop="showPoker($event,1)"></canvas>
                        <div class="bg-dark bg-opacity-25 position-absolute" :style="pearlLayerStyle" @mouseout.stop="showPoker($event,0)"></div>
                        <div v-if="isShowPearlMoreLayer" class="d-flex justify-content-center bg-dark bg-opacity-75 position-absolute top-0 start-0 w-100 h-100 text-light hover-bg-opacity-50">
                            <div class="d-flex flex-column justify-content-center">
                                <i class="d-flex bi bi-arrows-fullscreen p-2 fs-5" @click="showMorePearl(PEARL_TYPE.big_text)" role="button"></i>
                            </div>
                        </div>
                    </div>
                    <div :class="{'col-6 col-sm-3 h-xs-50 h-sm-100':pearlModel==1,'h-xs-33 col-sm-9 h-sm-50':pearlModel==2}" class="position-relative">
                        <canvas id="bigPearl" class="bg-light d-block min-w-100 min-h-100 mw-100 mh-100" v-set-size="6" data-canvas-room="6" width="0" height="0"></canvas>
                        <div v-if="isShowPearlMoreLayer" class="d-flex justify-content-center bg-dark bg-opacity-75 position-absolute top-0 start-0 w-100 h-100 text-light hover-bg-opacity-50">
                            <div class="d-flex flex-column justify-content-center">
                                <i class="d-flex bi bi-arrows-fullscreen p-2 fs-5" @click="showMorePearl(PEARL_TYPE.big_hollow)" role="button"></i>
                            </div>
                        </div>
                    </div>
                    <div :class="{'col-12 col-sm-6 h-xs-50 h-sm-100':pearlModel==1,'h-xs-33 col-sm-9 h-sm-50':pearlModel==2}" class="d-flex flex-column">
                        <div class="d-flex h-50">
                            <div class="col-6 position-relative">
                                <canvas id="smallHollowPearl" class="bg-light d-block min-w-100 min-h-100 mw-100 mh-100" v-set-size="3" data-canvas-room="3" width="0" height="0"></canvas>
                                <div v-if="isShowPearlMoreLayer" class="d-flex justify-content-center bg-dark bg-opacity-75 position-absolute top-0 start-0 w-100 h-100 text-light hover-bg-opacity-50">
                                    <div class="d-flex flex-column justify-content-center">
                                        <i class="d-flex bi bi-arrows-fullscreen p-2 fs-5" @click="showMorePearl(PEARL_TYPE.small_hollow)" role="button"></i>
                                    </div>
                                </div>
                            </div>
                            <div class="col-6 position-relative">
                                <canvas id="smallSolidPearl" class="bg-light d-block min-w-100 min-h-100 mw-100 mh-100" v-set-size="3" data-canvas-room="3" width="0" height="0"></canvas>
                                <div v-if="isShowPearlMoreLayer" class="d-flex justify-content-center bg-dark bg-opacity-75 position-absolute top-0 start-0 w-100 h-100 text-light hover-bg-opacity-50">
                                    <div class="d-flex flex-column justify-content-center">
                                        <i class="d-flex bi bi-arrows-fullscreen p-2 fs-5" @click="showMorePearl(PEARL_TYPE.small_solid)" role="button"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex h-50">
                            <div class="col-6 position-relative">
                                <canvas id="bevelPearl" class="bg-light d-block min-w-100 min-h-100 mw-100 mh-100" v-set-size="3" data-canvas-room="3" width="0" height="0"></canvas>
                                <div v-if="isShowPearlMoreLayer" class="d-flex justify-content-center bg-dark bg-opacity-75 position-absolute top-0 start-0 w-100 h-100 text-light hover-bg-opacity-50">
                                    <div class="d-flex flex-column justify-content-center">
                                        <i class="d-flex bi bi-arrows-fullscreen p-2 fs-5" @click="showMorePearl(PEARL_TYPE.bevel)" role="button"></i>
                                    </div>
                                </div>
                            </div>
                            <div class="col-6 position-relative">
                                <canvas id="threePearl" class="bg-light d-block min-w-100 min-h-100 mw-100 mh-100" v-set-size="3" data-canvas-room="3" width="0" height="0"></canvas>
                                <div v-if="isShowPearlMoreLayer" class="d-flex justify-content-center bg-dark bg-opacity-75 position-absolute top-0 start-0 w-100 h-100 text-light hover-bg-opacity-50">
                                    <div class="d-flex flex-column justify-content-center">
                                        <i class="d-flex bi bi-arrows-fullscreen p-2 fs-5" @click="showMorePearl(PEARL_TYPE.big_three)" role="button"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 功能 -->
                <div class="d-flex flex-column flex-sm-row small text-light">
                    <!-- 切换模式 -->
                    <div v-if="!isShowPearlMoreLayer" class="col d-flex flex-column justify-content-center align-items-center px-1 bg-dark bg-opacity-75 border-_3 border-style-outset border-dark small bg-gradient" @click="pearlModel=pearlModel==1?2:1" role="button">
                        <i class="bi bi-arrow-left-right lh-1 mb-lg-1"></i>
                        <div class="d-flex flex-column align-items-center">
                            <span class="text-vertical">{{$t('room.toggleMode')}}</span>
                        </div>
                    </div>
                    <!-- 查看全部按钮 -->
                    <div class="col d-flex flex-column justify-content-center align-items-center px-1 bg-dark bg-opacity-75 border-_3 border-style-outset border-dark small bg-gradient" @click="isShowPearlMoreLayer=!isShowPearlMoreLayer" role="button">
                        <i v-show="!isShowPearlMoreLayer" class="bi bi-search lh-1 mb-lg-1"></i>
                        <i v-show="isShowPearlMoreLayer" class="bi bi-x-octagon lh-1 mb-lg-1"></i>
                        <div class="d-flex flex-column align-items-center">
                            <span v-show="!isShowPearlMoreLayer" class="text-vertical">{{$t("room.viewAll")}}</span>
                            <span v-show="isShowPearlMoreLayer" class="text-vertical">{{$t("common.close")}}</span>
                        </div>
                    </div>
                </div>
                <!-- 查看所有路单 -->
                <div :class="{'d-none':pearlMoreType==null}" class="position-absolute start-0 top-0 w-100 h-100">
                    <div class="w-100 h-100 bg-light">
                        <canvas id="fullPearl" v-move-x class="bg-light d-block min-w-100 min-h-100 mh-100 position-absolute end-0" width="0" height="0"></canvas>
                    </div>
                    <div class="position-absolute top-50 start-0 translate-middle-y p-2">
                        <i class="bi bi-caret-left-square-fill opacity-50 fs-1" @click="movePearlMore(-1)" role="button"></i>
                    </div>
                    <div class="position-absolute top-50 end-0 translate-middle-y p-2">
                        <i class="bi bi-caret-right-square-fill opacity-50 fs-1" @click="movePearlMore(1)" role="button"></i>
                    </div>
                    <div class="position-absolute bottom-0 start-50 translate-middle-x p-2">
                        <i class="d-flex bi bi-x-circle-fill opacity-75 fs-2" @click="pearlMoreType=null" role="button"></i>
                    </div>
                </div>
            </div>
            <!-- 音效 -->
            <audio-player v-show="false" ref="resultAudioPlayer" :isLoop="false" :isAutoPlayNext="false" :muted="!audioSwitch.resultAudio" :audio-list="resultAudioList.map(elm => elm.url)" />
        </div>
    </div>
    </div>
</template>
<script>
import {COMMAND,COLOR, GAME_ID,PEARL_TYPE,PEARL_CODE,REBATE_TYPE,IS_DEBUG,LAYER_TYPE,SUBMIT_RESULT,CANCEL_RESULT, IS_REBATE,LOGIN_MODE,RATIO,AMOUTN_ARR,MUTATION_TYPE,RESULT, GAME_MODEL,MARK_TYPE,RULE_TYPE, POKER_TYPE,USER} from "@/assets/js/config.js"
import mediaVideo from "@/components/public/video.vue";
import roomList from '@/components/public/roomList.vue';
import navbarVertical from '@/components/public/navbarVertical.vue';
import navbar from '@/components/public/navbar.vue';
import notice from '@/components/public/notice.vue';
import changeRoom from '@/components/public/changeRoom.vue'
import changeAmount from '@/components/public/changeAmount.vue'
import chip from '@/components/public/chip.vue'
import { useLayer } from '@/assets/js/useLayer';
import { getDeviceType,formatDate } from '@/assets/js/common.js'
export default {
    components: { 
        mediaVideo,
        roomList,
        changeRoom,
        navbarVertical,
        navbar,
        notice,
        changeAmount,
        chip
    },
    directives: {
        'set-size': {
            mounted(elem,binding){
                let _this=binding.instance;
                //设置画布大小
                _this.$root.setCanvasSize(elem);
                //绘制画布表格
                _this.$root.drawCanvasTable(elem,binding.value,false);
            }
        },
        'move-x':{
            mounted(elem,binding){
                let clickFn=(e,fn)=>{
                    elem.classList.add("untransition");
                    let clickX=e.pageX||e.targetTouches[0].pageX;//按下的x坐标
                    let width=getComputedStyle(elem).width.replace('px','');//总宽度
                    let parentWidth=getComputedStyle(elem.parentNode).width.replace('px','');//获取一版宽度
                    let left=Number(getComputedStyle(elem).left.replace('px',''));//左边距
                    fn(clickX,width,parentWidth,left);
                }
                let moveFn=(e,clickX,width,parentWidth,left)=>{
                    let moveX=e.pageX||(e.targetTouches&&e.targetTouches[0].pageX);//移动到的x坐标
                    let moveDistance=moveX-clickX;//移动的距离
                    let newLeft=left+moveDistance;//新的左边距
                    if(newLeft>0){//左边距不能大于0
                        newLeft=0;
                    }else if(Math.abs(newLeft)>width-parentWidth){//左边距不能小于总宽度-一版的宽度
                        newLeft=-(width-parentWidth);
                    }
                    elem.style.left=newLeft+"px";//新左边距=旧左边距+移动的距离
                }
                elem.onmouseup=(e1)=>{
                    elem.classList.remove("untransition");
                }
                elem.onmousedown=(e1)=>{
                    clickFn(e1,(clickX,width,parentWidth,left)=>{
                        document.onmousemove=(e2)=>{
                            moveFn(e2,clickX,width,parentWidth,left);
                        }
                    })
                }
                elem.ontouchstart=(e1)=>{
                    clickFn(e1,(clickX,width,parentWidth,left)=>{
                        document.ontouchmove=(e2)=>{
                            moveFn(e2,clickX,width,parentWidth,left);
                        }
                    })
                }
            }
        }
    },
    props: {
        hasChatMsg:false,//是否有未读的客服消息
        isPageReady:false,//页面是否加载完毕
        isFullscreen:{
            type:Boolean,
            default:false
        },//当前是否全屏
        userid:{
            type:String,
            default:""
        },
        authorize:{
            type:String,
            default:""
        },
        roomid:{
            type:String,
            default:""
        }
    },
    data() {
        return {
            COMMAND,
            PEARL_TYPE,//获取路单类型配置
            COLOR,//获取颜色配置
            GAME_ID,//获取游戏id列表配置
            REBATE_TYPE,//获取佣金方式配置
            GAME_MODEL,
            MARK_TYPE,//印记类型
            POKER_TYPE,
            IS_REBATE,//是否免佣
            pearlCount:{z:0,x:0,h:0,zd:0,xd:0},//统计
            pearlArr:[],//台面路单列表
            virtualPearlArr:[],//台面问路路单列表
            nextZHollowStyle:"",//下局预测Z空心样式
            nextZBevelStyle:"",//下局预测Z斜线样式
            nextZSolidStyle:"",//下局预测Z实心样式
            nextXHollowStyle:"",//下局预测X空心样式
            nextXBevelStyle:"",//下局预测X斜线样式
            nextXSolidStyle:"",//下局预测X实心样式
            odds:{z:"0",x:"0",h:"0",zd:"0",xd:"0"},//赔率
            limitred:{z:"0-0",x:"0-0",h:"0-0",zd:"0-0",xd:"0-0"},//限红
            pool:{z:0,x:0,zd:0,xd:0,h:0},//池
            coruscateArr:[],//闪烁位集合，存放将要闪烁的位置
            currRebate:REBATE_TYPE.rebate,//当前佣金模式
            amount:10,//选中额度
            currAmountListSort:[10,50,100,500,1000,5000,10000],//排序后的选中额度列表
            submited:[{z:0,x:0,h:0,zd:0,xd:0},{z:0,x:0,h:0,zd:0,xd:0}],//当前模式已提交的额度列表
            submiting:{z:0,x:0,h:0,zd:0,xd:0},//当前模式将要提交的额度列表
            canClear:false,//是否可以点击清除
            canCancel:false,//是否可以点击取消
            canConfirm:false,//是否可以点击确定
            pearlObj: {
                id:0,//台面id
                pearl:[]//路单数据
            },//要重绘路单的对象
            countList:[],//路单统计列表
            isMultiple:false,//是否显示多台
            isShowNextPrediction:false,//当前是否显示着问路
            resultAudioList:[
                {
                    url:require('@/assets/media/baccarat/win_he.mp3')
                },
                {
                    url:require('@/assets/media/baccarat/win_hu.mp3')
                },
                {
                    url:require('@/assets/media/baccarat/win_l.mp3')
                },
                {
                    url:require('@/assets/media/baccarat/win_x.mp3')
                },
                {
                    url:require('@/assets/media/baccarat/win_z.mp3')
                }
            ],//开结果音效
            pokerArr:[],//当前台面牌组
            showPokerArr:[],//要显示的牌组
            currPokerXY:[0,0],//当前要翻转的扑克
            pearlLayerStyle:{
                width:0,
                height:0,
                left:0,
                top:0,
                display:'none'
            },//鼠标移上路单的遮罩层
            point:[0,0],//鼠标在路单上的坐标点
            videoList:[],//视频线路地址，当前支持最多两个
            isShowMoreAmount:false,//是否显示更多筹码
            isShowPoker:true,//鼠标移入画布是否显示牌
            isShowPokerCompare:true,//是否显示牌的大小比较
            isShowPokerLayer:true,//是否显示牌
            isModuleReady:false,//页面内组件是否加载完成
            isShowPearlMoreLayer:false,//是否显示查看全部路单遮罩层
            pearlMoreType:null,//当前显示的全部路单数据的类型
            pearlModel:1,//路子模式（1:模式1 2:模式2）
            readyVideoIdArr:[],//已加载好的视频id
            showPokerTimer:null,//显示牌计时器
            currRuleType:1,//玩家当前显示的玩法（1:十二生肖 2:十八罗汉 3:二十四节气）
            activeRuleType:0,//玩家当前已激活的玩法
            isShowMark:false,//是否显示连中印记
            isShowRule:false,//是否显示规则说明
            markOdds:[],//印记玩法返利
            isShowGetMark:false,//是否显示得到印记动画
            lastVideoLine:"",//上一次获取视频的视频线路id
            //新版台参数
            isScale:false,//是否放大提交区和视频区
            isScaleAmount:{z:false,x:false,h:false,zd:false,xd:false},//是否放大码额
            isHaveMark:window[USER].tryBelong=="Company"?true:false,//是否有印记活动
            authorizeObj:{},//授权参数
            realUserId:"",//真实用户id
        };
    },
    computed: {
        userInfo() {
            return this.$store.state.userInfo;
        },
        roomInfo() {
            return this.$store.state.roomInfo;
        },
        tabGame(){
            return this.$store.state.tabGame;
        },
        currVideoLine(){
			return this.$store.state.currVideoLine;
		},
        audioSwitch(){
            return this.$store.state.audioSwitch;
        },
        gameModel(){
            return this.$store.state.gameModel;
        },
        videoLineList(){
            return this.$store.state.videoLineList;
        },
        currAmountList(){
            return this.$store.state.currAmountList;
        },
        userAmountList(){
            return this.$store.state.userAmountList;
        },
        roomList(){
            return this.$store.state.roomList;
        },
        tableColumnList(){
            return this.$store.state.tableColumnList;
        },
    },
    created() {
        if(!this.userid){
            this.authorizeObj.error="用户参数缺失";
        }
        if(!this.authorize){
            this.authorizeObj.error="授权参数缺失";
        }
        if(!this.roomid){
            this.authorizeObj.error="台面参数缺失";
        }
        if(this.authorizeObj.error){
            document.body.innerText="window.authorize:"+JSON.stringify(this.authorizeObj);
            return;
        }
        let wsUrl=Object.values(window[USER].ws)[1];
        let ws=new WebSocket(wsUrl);
        this.$root.ws=ws;
        ws.onopen=()=> {
            IS_DEBUG&&console.log("连接建立");
            this.$emit("ws-send",COMMAND.all_login, this.userid, this.authorize, getDeviceType(), this.$root.ip.cip,window[USER].tryBelong,4);
        }
        ws.onerror=()=>{
            this.authorizeObj.error="数据服务器连接失败";
        }
        this.$root.onMessage();
        this.setWsMessage();
        this.currRuleType=this.userInfo.markType;
    },
    mounted() {
        // layer.closeAll();
        // this.init();
        addEventListener("resize",this.setResize);
    },
    unmounted() {
        removeEventListener("resize",this.setResize);
        delete this.$root.wsMsgObj["bac"];
    },
    methods: {
        init(){
            //获取台面视频
            if(this.currVideoLine==""){
                useLayer({str:this.$t("video.noVideoLine")});
            }else{
                this.$emit("ws-send",COMMAND.all_getvideo,this.roomInfo.id,this.currVideoLine,this.userInfo.id,this.userInfo.guid);
                this.lastVideoLine=this.currVideoLine;
            }
            if(this.roomInfo.pokermode==POKER_TYPE.normal){//普通台正常获取赔率，明牌台需要获取牌之后再获取赔率
                this.$emit("ws-send",COMMAND.bac_getodds,this.roomInfo.id,this.userInfo.id,this.userInfo.guid);
            }
            //获取限红
            this.$root.wsSendJson({
                command:COMMAND.all_getlimitredinfo,
                game:this.roomInfo.game,
                userid:this.userInfo.id,
                guid:this.userInfo.guid
            });
            //获取各位置已提交额度
            this.$emit("ws-send",COMMAND.bac_getbetdetail,this.roomInfo.id,this.roomInfo.boot,this.roomInfo.innings,this.userInfo.id,this.userInfo.guid);
            //获取台面路单
            this.$root.getRoomPearl(this.roomInfo.game,this.roomInfo.id);
            //获取台面扑克
            this.$emit("ws-send",COMMAND.bac_getroompoker, this.roomInfo.id,this.roomInfo.boot,-1,this.userInfo.id, this.userInfo.guid);
            //获取玩法配置信息
            this.$emit("ws-send",COMMAND.all_getrule,RULE_TYPE.mark, this.userInfo.id,this.userInfo.guid);
            //不能免佣则重置佣金模式为非免佣
            this.roomInfo.iscommission==IS_REBATE.false&&(this.currRebate=REBATE_TYPE.rebate);
        },
        /**
         * 设置websocket响应事件
         */
        setWsMessage(){
            this.$root.wsMsgObj["bac"]=(data)=>{
                switch (data.command) {
                    case COMMAND.all_login:
                        if (data.result==RESULT.login.success) {
                            this.realUserId=data.id;
                            this.$store.commit({
                                type:MUTATION_TYPE.setUserInfo,
                                userInfo:{
                                    id:this.realUserId,
                                    guid:data.guid
                                }
                            })
                            this.$emit("ws-send",COMMAND.all_online, this.userInfo.id, data.guid);
                            this.$emit("ws-send",COMMAND.all_getuserinfo,this.userInfo.id, data.guid);
                            this.$emit('ws-send',COMMAND.all_getline,this.userInfo.id, data.guid);
                            this.$emit("ws-send",COMMAND.all_getroomlist, 1,this.userInfo.id, data.guid);
                        }else{
                            this.authorizeObj.error="用户登录失败";
                        }
                        break;
                    case COMMAND.all_getroomlist:
                        if(!data.list.find(v=>v.id==this.roomid)){
                            this.authorizeObj.error="台面参数错误";
                            return;
                        }
                        this.$emit("ws-send",COMMAND.all_entertable, 1, this.roomid,this.userInfo.id, this.userInfo.guid);
                        break;
                    case COMMAND.all_getline:
                        this.$store.commit({
                            type:MUTATION_TYPE.setVideoLineList,
                            videoLineList:data.list
                        })
                        break;

                    case COMMAND.all_getroompearl:
                        if(data.id==this.roomInfo.id){//获取的是当前台面的数据
                            this.pearlArr=data.pearl;
                        }
                        if(this.roomList&&this.roomList.find(v=>v.id==data.id)){//用于切换台面功能获取数据，换台列表中有才需要更新
                            this.pearlObj={
                                id:data.id,
                                pearl:data.pearl
                            }
                            this.countList[data.id]=data.count;
                        }
                        break;
                    case COMMAND.all_getvideo:
                        let videoArr=data.video;
                        let list=[];//拼装好的视频地址数组
                        for (let i = 0; i < videoArr.length; i++) {
                            list.push(data.flvline+'/'+videoArr[i]+'.flv');
                        }
                        this.videoList=list;
                        this.authorizeObj.video=list;
                        break;
                    case COMMAND.bac_getodds:
                        if(this.roomInfo.pokermode==POKER_TYPE.show){//明牌模式
                            this.odds={
                                z:0,
                                x:0,
                                h:0,
                                zd:0,
                                xd:0
                            }
                            if(this.showPokerArr.length>0&&(this.showPokerArr[0][0]||this.showPokerArr[1][0])){//任意一张牌出了，才能算赔率
                                let zNum=this.showPokerArr[0][0]?this.$root.getPokerByNum(this.showPokerArr[0][0]).name:3;//z没牌算3
                                let xNum=this.$root.getPokerByNum(this.showPokerArr[1][0]).name;
                                // let str="z"+((zNum<=6||zNum=='A')?6: (zNum>6&&zNum<=9)?zNum:0 )+"x"+((xNum<=6||xNum=='A')?6: (xNum>6&&xNum<=9)?xNum:0 );//拼个字符串，好匹配key
                                let str="z"+(zNum=='A'?1:(zNum<=9?zNum:0))+"x"+(xNum=='A'?1:(xNum<=9?xNum:0));//拼个字符串，好匹配key
                                let odd = data.odds.find(v=>v.key==str);
                                this.odds.z=odd.os[0];
                                this.odds.x=odd.os[1];
                                this.odds.h=odd.os[2];
                                this.odds.zd=odd.os[3];
                                this.odds.xd=odd.os[3];
                            }
                        }else if(this.roomInfo.pokermode==POKER_TYPE.normal){//正常模式
                            this.odds={
                                z:data.odds.z,
                                x:data.odds.x,
                                h:data.odds.h,
                                zd:data.odds.zd,
                                xd:data.odds.xd
                            }
                        }
                        break;
                    case COMMAND.all_endgame:
                        data.id==this.roomInfo.id&&this.resetAmount("submiting");
                        break;
                    case COMMAND.all_getcurrpoker:
                        // let len=data.poker.flat(Infinity).length;
                        // if(data.id==this.roomInfo.id&&((!data.isget)||(data.isget&&len>0&&len<3))){//是当前台的数据并且(是推送)(或者主动获取并且只有1~2张牌)
                        if(data.id==this.roomInfo.id&&((!data.isget)||(this.pokerArr.length>0&&String(this.pokerArr[this.pokerArr.length-1])!=String(data.poker)))){//是当前台的数据并且(是推送)(或者与pokerArr最新的一组牌不同，说明还没结束本轮)
                            this.isShowPoker=false;
                            this.isShowPokerCompare=false;
                            this.showPokerArr=data.poker;
                            this.currPokerXY=data.index;
                            this.roomInfo.pokermode==POKER_TYPE.show&&(this.isShowPokerLayer=true);
                        }
                        //由于明牌台赔率是根据牌动态改变的，所以需要在此获取
                        this.roomInfo.pokermode==POKER_TYPE.show&&this.$emit("ws-send",COMMAND.bac_getodds,this.roomInfo.id,this.userInfo.id,this.userInfo.guid);
                        break;
                    case COMMAND.all_settlement:
                        if(data.id==this.roomInfo.id){
                            this.isShowPoker=true;
                            if(this.roomInfo.pokermode==POKER_TYPE.show){//明牌台重置额度
                                this.odds={z:0,x:0,h:0,zd:0,xd:0}
                            }
                        }
                        break;
                    case COMMAND.all_getgain:
                        if(data.id==this.roomInfo.id){
                            setTimeout(() => {
                                this.resetAmount("all",2);
                            }, 5000);
                            if(data.win!=0||data.lose!=0){
                                useLayer({str:(data.win > Math.abs(data.lose)? this.$t("common.win"):this.$t("common.lose"))+Math.abs(data.win - data.lose)});
                                if(data.win-data.lose>0&&!this.isShowMark){//赢了并且没点开印记界面则显示获得印记效果
                                    this.isShowGetMark=true;
                                    setTimeout(() => {
                                        this.isShowGetMark=false;
                                    }, 2000);
                                }
                            }
                        }
                        break;
                    case COMMAND.bac_receivepool:
                        data.id==this.roomInfo.id&&(this.pool=data.pool);
                        break;
                    case COMMAND.bac_submitbet:
                        //默认失败音效
                        this.$root.$refs.tipAudioPlayer.currentPlayIndex=10;
                        this.$root.$refs.tipAudioPlayer.$refs.audio.currentTime = 0;
                        switch (data.result) {
                            case SUBMIT_RESULT.success:
                                //音效和提示
                                this.$root.$refs.tipAudioPlayer.currentPlayIndex=9;
                                useLayer({str:this.$t("common.subSuccess")});

                                this.$store.commit({
                                    type:MUTATION_TYPE.setUserInfo,
                                    userInfo:{
                                        realCoin:data.realmoney
                                    }
                                })
                                for (let i in this.submited[this.currRebate]) {//将本次提交的额度追加到已提交的额度中
                                    this.submited[this.currRebate][i]+=this.submiting[i];
                                }
                                //设置提交列表
                                this.$store.commit({
                                    type:MUTATION_TYPE.setCurrBetList,
                                    room:{
                                        game:this.roomInfo.game,
                                        id:this.roomInfo.id,
                                        detail:JSON.parse(JSON.stringify(this.submited)),
                                        winArr:[]
                                    }
                                })
                                this.resetAmount("submiting");//清空将提交额度列表
                                break;
                            case SUBMIT_RESULT.ban:
                                useLayer({str:this.$t("common.subBan")});
                                break;
                            case SUBMIT_RESULT.unmoney:
                                useLayer({str:this.$t("common.unMoney")});
                                break;
                            case SUBMIT_RESULT.countdown:
                                useLayer({str:this.$t("common.subCountdown")});
                                break;
                            case SUBMIT_RESULT.outside:
                                useLayer({str:this.$t("common.unLimit")});
                                break;
                            case SUBMIT_RESULT.service:
                                useLayer({str:this.$t("common.service")});
                                break;
                            case SUBMIT_RESULT.malice:
                                useLayer({str:""});
                                break;
                            default:
                                useLayer({str:this.$t("common.subErr")});
                                break;
                        }
                        this.$nextTick(()=>{
                            this.$root.$refs.tipAudioPlayer.play();
                        })
                        break;
                    case COMMAND.all_cancelbet:
                        if(data.result==CANCEL_RESULT.success){
                            this.resetAmount("all",2);
                            this.$store.commit({
                                type:MUTATION_TYPE.setUserInfo,
                                userInfo:{
                                    realCoin:data.realmoney
                                }
                            })
                            useLayer({str:this.$t("common.cancelSuccess")});
                        }else{
                            useLayer({str:this.$t("common.cancelErr")});
                        }
                        break;
                    case COMMAND.all_changeboot:
                        if(data.id==this.roomInfo.id){
                            this.pearlArr=[];
                            this.pokerArr=[];
                            this.$store.commit({
                                type:MUTATION_TYPE.setRoomInfo,
                                roomInfo:{
                                    boot:data.boot,
                                    innings:data.innings
                                }
                            })
                        }
                        break;
                    case COMMAND.bac_getbetdetail:
                        if(data.id==this.roomInfo.id){    
                            this.submited=[
                                {
                                    z:Number(data.detail[0].z),
                                    x:Number(data.detail[0].x),
                                    h:Number(data.detail[0].h),
                                    zd:Number(data.detail[0].zd),
                                    xd:Number(data.detail[0].xd)
                                },{
                                    z:Number(data.detail[1].z),
                                    x:Number(data.detail[1].x),
                                    h:Number(data.detail[1].h),
                                    zd:Number(data.detail[1].zd),
                                    xd:Number(data.detail[1].xd)
                                }
                            ]
                        }
                        break;
                    case COMMAND.all_entertable:
                        this.authorizeObj.room=data.room+data.table;
                        this.authorizeObj.round=data.boot+"-"+data.innings;
                        this.authorizeObj.countdown=data.countdown||0;
                        console.log("-----")
                        console.log(JSON.stringify(this.authorizeObj));

                        this.showPokerArr=[];
                        this.$root.$refs.startAudioPlayer.pause();
                        this.$root.$refs.endAudioPlayer.pause();
                        this.$root.$refs.tenAudioPlayer.pause();
                        this.$refs.resultAudioPlayer.pause();
                        this.pokerArr=[];
                        this.isShowPearlMoreLayer=false;
                        this.pearlMoreType=null;
                        // data.iscommission==IS_REBATE.false&&(this.currRebate=REBATE_TYPE.rebate);//不能免佣则重置佣金模式为非免佣
                        this.init();
                        this.resetAmount("submiting");
                        break;
                    case COMMAND.bac_getroompoker:
                        let arr=data.list;
                        for (let i = 0; i < arr.length; i++) {
                            // arr[i].zp.length>0&&arr[i].xp.length>0&&
                            this.pokerArr.push([arr[i].zp,arr[i].xp]);
                        }
                        if(this.roomInfo.pokermode==POKER_TYPE.show){//明牌台需要获取牌，放在这是确保pokerArr有值
                            this.$emit("ws-send",COMMAND.all_getcurrpoker,this.roomInfo.game, this.roomInfo.id, this.userInfo.id,this.userInfo.guid);
                        }
                        break;
                    case COMMAND.bac_gameresult:
                        if(data.id==this.roomInfo.id){
                            this.currPokerXY=[0,0];
                            this.updatePearl(this.pearlArr,data.pearl);
                            this.setCoruscate(data.pearl);
                            this.isShowPokerCompare=true;
                            if(data.zpoker.length>0&&data.xpoker.length>0){//有牌
                                this.showPokerArr=[data.zpoker,data.xpoker];
                                this.pokerArr.push(this.showPokerArr);
                                setTimeout(() => {
                                    this.showPokerArr=[];
                                }, 5000);
                            }
                        }
                        break;
                    case COMMAND.all_setruletype:
                        if(data.result==1){//成功
                            let mark=0;//默认重置进度
                            if(data.type>this.userInfo.markType){//升级需要继承进度
                                mark=this.userInfo.mark;
                            }
                            this.$store.commit({
                                type:MUTATION_TYPE.setUserInfo,
                                userInfo:{
                                    markType:data.type==0?this.userInfo.markType:data.type,
                                    mark:mark
                                }
                            })
                            this.activeRuleType=this.currRuleType;
                        }else{
                            useLayer({str:this.$t("room.activationFailed")});
                        }
                        break;
                    case COMMAND.all_getrule:
                        this.markOdds=[data.z12,data.z18,data.z24];
                        break;
                    case COMMAND.all_startgame:
                        if(data.id==this.roomInfo.id){
                            this.roomInfo.pokermode==POKER_TYPE.show&&(this.isShowPokerLayer=false);
                        }
                        break;
                    case COMMAND.all_getlimitredinfo:
                        this.limitred={
                            z:data.limitred.z,
                            x:data.limitred.x,
                            h:data.limitred.h,
                            zd:data.limitred.zd,
                            xd:data.limitred.xd,
                            z6:data.limitred.z1,
                            z26:data.limitred.z2,
                            z36:data.limitred.x1,
                            x7z6:data.limitred.x2
                        }
                        this.autoAmount();
                        break;
                }
            }
        },
        /**
         * 设置窗口大小改变
         */
        setResize(){
            this.drawPearl(this.pearlArr);
            this.drawMorePearl(this.pearlMoreType);
        },
        /**
         * 设置闪烁位
         */
        setCoruscate(pearl,fn){
            let arr=[];
            pearl=pearl.substr(0,1);
            if(PEARL_CODE.Z.indexOf(pearl) != -1){
                arr.push('z');
                this.$refs.resultAudioPlayer.currentPlayIndex=(this.roomInfo.game==GAME_ID.bac?4:2);
                this.$nextTick(()=>{
                    this.$refs.resultAudioPlayer.play();
                })
            }else if(PEARL_CODE.X.indexOf(pearl) != -1){
                arr.push('x');
                this.$refs.resultAudioPlayer.currentPlayIndex=(this.roomInfo.game==GAME_ID.bac?3:1);
                this.$nextTick(()=>{
                    this.$refs.resultAudioPlayer.play();
                })
            }else if(PEARL_CODE.H.indexOf(pearl) != -1){
                arr.push('h');
                this.$refs.resultAudioPlayer.currentPlayIndex=0;
                this.$nextTick(()=>{
                    this.$refs.resultAudioPlayer.play();
                })
            }
            PEARL_CODE.ZD.indexOf(pearl) != -1 && arr.push('zd');
            PEARL_CODE.XD.indexOf(pearl) != -1 && arr.push('xd');
            this.coruscateArr=arr;
            setTimeout(() => {
                this.coruscateArr=[];
                fn&&fn();
            }, 5000);
        },
        /**
         * 设置当前佣金模式
         */
        setRebate(e){
            if(this.roomInfo.iscommission==IS_REBATE.false){//不能免佣
                useLayer({str:this.$t("video.noChangeRebate")});
                e.target.checked=false;
            }else{//可以免佣
                let fn=()=>{
                    if(this.currRebate==REBATE_TYPE.rebate){
                        this.currRebate=REBATE_TYPE.noRebate;
                    }else if(this.currRebate==REBATE_TYPE.noRebate){
                        this.currRebate=REBATE_TYPE.rebate;
                    }
                    this.resetAmount("submiting");
                    //获取各位置已提交额度
                    this.$emit("ws-send",COMMAND.bac_getbetdetail,this.roomInfo.id,this.roomInfo.boot,this.roomInfo.innings,this.userInfo.id,this.userInfo.guid);
                }
                if(this.getAmountCount("submiting")!=0){//有未提交的额度
                    e.target.checked=!e.target.checked;
                    useLayer({
                        type:LAYER_TYPE.confirm,
                        str:this.$t("room.isChangeRebate"),
                        btn:[this.$t("common.yes"),this.$t("common.no")],
                        yesFn:(i)=>{
                            fn();
                            layer.close(i);
                        }
                    });
                }else{//没有未提交的项
                    fn();
                }
            }
        },
        /**
         * 提交事件
         */
        submitEvent(event){
            switch (event) {
                case "clear"://点击清除
                    this.getAmountCount("submiting")!=0&&this.resetAmount("submiting");
                    break;
                case "cancel"://点击取消
                    if(this.canCancel){
                        useLayer({
                            type:LAYER_TYPE.confirm,
                            str:this.$t("common.isCancel"),
                            btn:[this.$t("common.yes"),this.$t("common.no")],
                            yesFn:(i)=>{
                                layer.close(i);
                                this.$emit("ws-send",COMMAND.all_cancelbet,this.roomInfo.game,this.roomInfo.id,this.roomInfo.boot,this.roomInfo.innings,this.userInfo.id,this.userInfo.guid);
                            }
                        })
                    }
                    break;
                case "confirm"://点击确定
                    if(this.canConfirm){
                        this.$emit("ws-send",COMMAND.bac_submitbet,this.roomInfo.game,this.roomInfo.id,this.roomInfo.boot,this.roomInfo.innings,
                            this.getAmountCount("submiting"),this.getAmountCount("submiting")+this.getAmountCount("submited",REBATE_TYPE.rebate)+this.getAmountCount("submited",REBATE_TYPE.noRebate),this.currRebate,
                            String(this.submiting.z)+","+String(this.submiting.x)+","+String(this.submiting.h)+","+String(this.submiting.zd)+","+String(this.submiting.xd)+",0,0,0,0",
                            this.userInfo.id,this.$root.ip.cip,getDeviceType(),this.userInfo.guid);
                    }
                    break;
                case "multiple"://点击多台
                    this.isMultiple=!this.isMultiple;//变换模式
                    if(this.tabGame!=GAME_ID.bac){//当前选项卡选中别的游戏则需要重新获取台列表
                        this.roomList=[];
                        if(!this.isMultiple){//非多台，重绘路单
                            this.$nextTick(()=>{
                                this.pearlArr=JSON.parse(JSON.stringify(this.pearlArr));
                            })
                        }
                        this.$emit("ws-send",COMMAND.all_getroomlist, this.isMultiple?this.roomInfo.game:this.tabGame,this.userInfo.id, this.userInfo.guid);
                    }
                    break;
            }
        },
        /**
         * 为位置追加将要提交的额度
         * @param {String} type 位置类型(z、x、h、zd、xd)
         */
        addAmount(type,event){
            let limitred=this.limitred[type].split('-');//获取限红
            let amount=this.amount;
            if(!this.odds[type]){
                useLayer({str:this.$t("room.odds0")});
                return;
            }
            if(this.roomInfo.countdown<=0){
                useLayer({str:this.$t("room.noStartGame")});
                return;
            }else if(this.userInfo.realCoin<this.getAmountCount("submiting")+amount){//余额不足
                useLayer({str:this.$t("common.unMoney")});
                return;
            }
            if(amount!=-1){//非满额度
                if(amount>limitred[1]){//单次高于上限
                    useLayer({str:this.$t("room.higherLimitred")+limitred[1]});
                    return;
                }else if(this.submiting[type]+this.submited[this.currRebate][type]+amount>limitred[1]){//多次并高于上限
                    useLayer({str:this.$t("room.laveLimitred")+(limitred[1]-this.submiting[type]-this.submited[this.currRebate][type])});
                    return;
                }
            }else{//满额度
                amount=limitred[1]-this.submiting[type]-this.submited[this.currRebate][type];
                if(amount==0){
                    useLayer({str:this.$t("room.fullAmount")});
                    return;
                }
            }
            this.submiting[type]=this.submiting[type]+amount;
            if(event){
                this.isScaleAmount[type]=true;
                setTimeout(() => {
                    this.isScaleAmount[type]=false;
                }, 120);
            }
        },
        /**
         * 获取额度
         * @param {String} type 额度类型(submited、submiting、all)
         * @param {Number} rebate 免佣类型(0:非免佣 1:免佣 2:免佣+非免佣)
         */
        getAmountCount(type,rebate){
            let count=0;
            if(type=="submiting"||type=="all"){//预投或总投
                for (let i in this.submiting) {
                    count+=this.submiting[i];
                }
            }
            if(type=="submited"||type=="all"){//已投或总投
                if(rebate==REBATE_TYPE.rebate||rebate==2){//累计非免佣
                    for (let i in this.submited[REBATE_TYPE.rebate]) {
                        count+=this.submited[REBATE_TYPE.rebate][i];
                    }
                }
                if(rebate==REBATE_TYPE.noRebate||rebate==2){//累计免佣
                    for (let i in this.submited[REBATE_TYPE.noRebate]) {
                        count+=this.submited[REBATE_TYPE.noRebate][i];
                    }
                }
            }
            return count;
        },
        /**
         * 重置额度
         * @param {String} type 额度类型(submited、submiting、all)
         * @param {Number} rebate 免佣类型(0:非免佣 1:免佣 2:免佣+非免佣)
         */
        resetAmount(type,rebate){
            if(type=="submiting"||type=="all"){//预投或总投
                for (let i in this.submiting) {
                    this.submiting[i]=0;
                }
            }
            if(type=="submited"||type=="all"){//已投或总投
                if(rebate==REBATE_TYPE.rebate||rebate==2){//重置非免佣
                    for (let i in this.submited[REBATE_TYPE.rebate]) {
                        this.submited[REBATE_TYPE.rebate][i]=0;
                    }
                }
                if(rebate==REBATE_TYPE.noRebate||rebate==2){//重置免佣
                    for (let i in this.submited[REBATE_TYPE.noRebate]) {
                        this.submited[REBATE_TYPE.noRebate][i]=0;
                    }
                }
            }
        },
        /**
         * 问路
         */
        nextPrediction(pearl){
            if(!this.isShowNextPrediction){//当前没有在显示问路，防止多次点击
                this.isShowNextPrediction=true;
                let virtualArr=JSON.parse(JSON.stringify(this.pearlArr));//深克隆一个虚拟数组
                this.updatePearl(virtualArr,pearl);
                this.drawPearl(virtualArr);
                this.nextPredictionTimer = setTimeout(() => {
                    this.drawPearl(this.pearlArr);
                    this.isShowNextPrediction=false;
                }, 1000);
            }
        },
        /**
		 * 更新路单信息
		 * @param {Array} pearlArr 路单列表
		 * @param {String} pearl 路单数据
		 */
		updatePearl(pearlArr,pearl){
			if (pearlArr && pearlArr.length > 0 && (
				(PEARL_CODE.Z.indexOf(pearl.substr(0, 1)) != -1 && PEARL_CODE.Z.indexOf(pearlArr[pearlArr.length - 1][0].substr(0, 1)) != -1) ||
				(PEARL_CODE.X.indexOf(pearl.substr(0, 1)) != -1 && PEARL_CODE.X.indexOf(pearlArr[pearlArr.length - 1][0].substr(0, 1)) != -1) ||
				(PEARL_CODE.H.indexOf(pearl.substr(0, 1)) != -1 && PEARL_CODE.H.indexOf(pearlArr[pearlArr.length - 1][0].substr(0, 1)) != -1)
				)) {//如果当前的露珠类型与上一项同类，则加到上一项的队列中
				pearlArr[pearlArr.length - 1].push(pearl);
			} else {//否则新建自己的队列
				pearlArr.push([pearl]);
			}
		},
        /**
         * 绘制路单
         */
        drawPearl(pearlArr){
            if(!this.isMultiple){//非多台
                //画表格
                let elemList = document.querySelectorAll("[data-canvas-room]");
                for (let elem of elemList){
                    let val=elem.dataset.canvasRoom;//获取data-canvas-room属性的值
                    //设置画布大小
                    this.$root.setCanvasSize(elem);
                    //绘制画布表格
                    let obj = this.$root.drawCanvasTable(elem,val,false);
                    if(obj){//判断对象是否存在，防止视口被拉小到没有的时候找不到而报错
                        if(obj.elem.id=='textBigPearl'){
                            //设置移入带字大路区的遮罩层大小
                            this.pearlLayerStyle.width=obj.cellWidth/RATIO+'px';
                            this.pearlLayerStyle.height=obj.cellHeight/RATIO+'px';
                        }
                        //画路单
                        if(pearlArr.length>0){
                            var delTieArr=this.$root.setPearlData(this.roomInfo.game,pearlArr,Infinity,false);//第一次调用setPearlData是为了去掉和，此时并无法确定要保留多少列
                            if(obj.elem.id=="textBigPearl"){
                                let countArr= this.$root.drawOrderPearl(obj,pearlArr,PEARL_TYPE.big_text);
                                this.pearlCount.z=countArr[0];
                                this.pearlCount.x=countArr[1];
                                this.pearlCount.h=countArr[2];
                                this.pearlCount.zd=countArr[3];
                                this.pearlCount.xd=countArr[4];
                            }else if(obj.elem.id=="threePearl"){
                                this.$root.drawOrderPearl(obj,pearlArr,PEARL_TYPE.big_three);
                            }else if(obj.elem.id=="bigPearl"){
                                this.$root.drawPearl(obj,this.$root.setPearlData(this.roomInfo.game,pearlArr,obj.column-1,false),PEARL_TYPE.big_hollow,GAME_ID.bac);
                            }else if(obj.elem.id=="smallHollowPearl"){
                                this.$root.drawPearl(obj,
                                    this.$root.setPearlData(this.roomInfo.game,this.$root.convertToSmallPearl(delTieArr,PEARL_TYPE.small_hollow),obj.column*2-1,false),//第二次调用setPearlData是为了保留多少列
                                    PEARL_TYPE.small_hollow,GAME_ID.bac);
                            }else if(obj.elem.id=="smallSolidPearl"){
                                this.$root.drawPearl(obj,
                                    this.$root.setPearlData(this.roomInfo.game,this.$root.convertToSmallPearl(delTieArr,PEARL_TYPE.small_solid),obj.column*2-1,false),//第二次调用setPearlData是为了保留多少列
                                    PEARL_TYPE.small_solid,GAME_ID.bac);
                            }else if(obj.elem.id=="bevelPearl"){
                                this.$root.drawPearl(obj,
                                    this.$root.setPearlData(this.roomInfo.game,this.$root.convertToSmallPearl(delTieArr,PEARL_TYPE.bevel),obj.column*2-1,false),//第二次调用setPearlData是为了保留多少列
                                    PEARL_TYPE.bevel,GAME_ID.bac);
                            }
                        }
                    }
                }
                //更新下局预测
                if(pearlArr.length>0){
                    if(delTieArr&&delTieArr.length>0){//判断去掉和之后的数组长度大于0，防止第一口为和时报错
                        let lastLetter=delTieArr[delTieArr.length-1][0].substring(0,1);//获取最后一列的第一项的首字母
                        let str;
                        if(PEARL_CODE.Z.indexOf(lastLetter)!=-1){//判断最后一列是Z类
                            //下局z
                            str=String(this.$root.convertToSmallPearl(
                                        delTieArr.slice(-2,-1).concat([delTieArr.slice(-1).flat().concat(lastLetter)]),
                                        PEARL_TYPE.small_hollow
                                    ).flat().slice(-1));
                            this.nextZHollowStyle="color:"+(str?(str=='A'?COLOR.red:COLOR.blue):'inherit');//取倒数第二列拼上追加了虚拟项的倒数第一列
                            str=String(this.$root.convertToSmallPearl(
                                        delTieArr.slice(-3,-1).concat([delTieArr.slice(-1).flat().concat(lastLetter)]),
                                        PEARL_TYPE.bevel
                                    ).flat().slice(-1));
                            this.nextZBevelStyle="background:"+(str?(str=='A'?COLOR.red:COLOR.blue):'inherit');
                            str=String(this.$root.convertToSmallPearl(
                                        delTieArr.slice(-4,-1).concat([delTieArr.slice(-1).flat().concat(lastLetter)]),
                                        PEARL_TYPE.small_solid
                                    ).flat().slice(-1));
                            this.nextZSolidStyle="background:"+(str?(str=='A'?COLOR.red:COLOR.blue):'inherit');
                            //下局x
                            str=String(this.$root.convertToSmallPearl(
                                        delTieArr.slice(-2).concat([['B']]),
                                        PEARL_TYPE.small_hollow
                                    ).flat().slice(-1));
                            this.nextXHollowStyle="color:"+(str?(str=='A'?COLOR.red:COLOR.blue):'inherit');//取倒数第二列拼上追加了虚拟项的倒数第一列
                            str=String(this.$root.convertToSmallPearl(
                                        delTieArr.slice(-3).concat([['B']]),
                                        PEARL_TYPE.bevel
                                    ).flat().slice(-1));
                            this.nextXBevelStyle="background:"+(str?(str=='A'?COLOR.red:COLOR.blue):'inherit');
                            str=String(this.$root.convertToSmallPearl(
                                        delTieArr.slice(-4).concat([['B']]),
                                        PEARL_TYPE.small_solid
                                    ).flat().slice(-1));
                            this.nextXSolidStyle="background:"+(str?(str=='A'?COLOR.red:COLOR.blue):'inherit');
                        }else if(PEARL_CODE.X.indexOf(lastLetter)!=-1){//X类
                            //下局z
                            str=String(this.$root.convertToSmallPearl(
                                        delTieArr.slice(-2).concat([['A']]),
                                        PEARL_TYPE.small_hollow
                                    ).flat().slice(-1));
                            this.nextZHollowStyle="color:"+(str?(str=='A'?COLOR.red:COLOR.blue):'inherit');//取倒数第二列拼上追加了虚拟项的倒数第一列
                            str=String(this.$root.convertToSmallPearl(
                                        delTieArr.slice(-3).concat([['A']]),
                                        PEARL_TYPE.bevel
                                    ).flat().slice(-1))
                            this.nextZBevelStyle="background:"+(str?(str=='A'?COLOR.red:COLOR.blue):'inherit');
                            str=String(this.$root.convertToSmallPearl(
                                        delTieArr.slice(-4).concat([['A']]),
                                        PEARL_TYPE.small_solid
                                    ).flat().slice(-1));
                            this.nextZSolidStyle="background:"+(str?(str=='A'?COLOR.red:COLOR.blue):'inherit');
                            //下局x
                            str=String(this.$root.convertToSmallPearl(
                                        delTieArr.slice(-2,-1).concat([delTieArr.slice(-1).flat().concat(lastLetter)]),
                                        PEARL_TYPE.small_hollow
                                    ).flat().slice(-1));
                            this.nextXHollowStyle="color:"+(str?(str=='A'?COLOR.red:COLOR.blue):'inherit');//取倒数第二列拼上追加了虚拟项的倒数第一列
                            str=String(this.$root.convertToSmallPearl(
                                        delTieArr.slice(-3,-1).concat([delTieArr.slice(-1).flat().concat(lastLetter)]),
                                        PEARL_TYPE.bevel
                                    ).flat().slice(-1));
                            this.nextXBevelStyle="background:"+(str?(str=='A'?COLOR.red:COLOR.blue):'inherit');
                            str=String(this.$root.convertToSmallPearl(
                                        delTieArr.slice(-4,-1).concat([delTieArr.slice(-1).flat().concat(lastLetter)]),
                                        PEARL_TYPE.small_solid
                                    ).flat().slice(-1));
                            this.nextXSolidStyle="background:"+(str?(str=='A'?COLOR.red:COLOR.blue):'inherit');
                        }
                    }
                }else{
                    this.pearlCount={z:0,x:0,h:0,zd:0,xd:0};//清空统计
                    this.nextZHollowStyle="";
                    this.nextZBevelStyle="";
                    this.nextZSolidStyle="";
                    this.nextXHollowStyle="";
                    this.nextXBevelStyle="";
                    this.nextXSolidStyle="";
                }
            }
        },
        /**
         * 显示牌
         * @param {Number} type 移入或移出
         */
        showPoker(e,type){
            if(this.pearlLayerStyle.width!=0&&this.pearlLayerStyle.height!=0){//避免页面未加载完时鼠标移入路区报错
                if(type==1){//移入
                    if(this.isShowPoker){
                        let cellWidth=this.pearlLayerStyle.width.replace('px','');
                        let cellHeight=this.pearlLayerStyle.height.replace('px','');
                        let column=(getComputedStyle(e.target).width.replace('px','')/cellWidth).toFixed();//获取总列数
                        let x = Math.ceil(e.offsetX / cellWidth);//列
                        let y = Math.ceil(e.offsetY / cellHeight);//行
                        let array=this.pearlArr.flat(Infinity);
                        let pokerArr=this.pokerArr.slice(-(column - 1) * 6 - array.length % 6);//取倒数的数据
                        let poker=pokerArr[(x-1)*6+(y-1)];//获取对应位置的扑克
                        if((x!=this.point[0]||y!=this.point[1])&&x!=0&&y!=0&&poker&&poker.flat(Infinity).length>0){//坐标点相比于上次有不同并且大于0行0列并且对应位置有扑克数据
                            this.point=[x,y];
                            this.$nextTick(()=>{
                                this.pearlLayerStyle.display='block';
                                this.pearlLayerStyle.left=(x-1)*cellWidth+'px';
                                this.pearlLayerStyle.top=(y-1)*cellHeight+'px';
                                this.showPokerArr=poker;
                                this.showPokerTimer&&clearTimeout(this.showPokerTimer);
                                this.showPokerTimer = setTimeout(() => {
                                    this.showPokerArr=[];
                                }, 5000);
                                this.roomInfo.pokermode==POKER_TYPE.show&&(this.isShowPokerLayer=true);
                            })
                        }else{
                            this.showPokerArr=[];
                            this.pearlLayerStyle.display='none';
                            this.point=[0,0];
                        }
                    }
                }else{//移出
                    this.showPokerArr=[];
                    this.pearlLayerStyle.display='none';
                    this.point=[0,0];
                    this.showPokerTimer&&clearTimeout(this.showPokerTimer);
                }
            }
        },
        /**
         * 根据牌获取点数
         */
        getPoint(pokerArr){
            if(this.roomInfo.game==GAME_ID.bac){
                return pokerArr.reduce((prev,val)=>prev+(Math.ceil(val/4)>10?10:Math.ceil(val/4)),0)%10||0;
            }else{
                return pokerArr.reduce((prev,val)=>prev+Math.ceil(val/4),0)||0;
            }
        },
        /**
         * 牌是否赢
         */
        isPokerWin(index){
            if(this.roomInfo.game==GAME_ID.bac){
                let sumArr = this.showPokerArr.map(v=>v.reduce((prev,val)=>prev+(Math.ceil(val/4)>10?10:Math.ceil(val/4)),0)%10);
                return sumArr[index]>sumArr[1-index]?true:false;
            }else{
                let sumArr = this.showPokerArr.map(v=>v.reduce((prev,val)=>prev+Math.ceil(val/4),0));
                return sumArr[index]>sumArr[1-index]||(sumArr[index]==sumArr[1-index]&&this.showPokerArr[index]>this.showPokerArr[1-index])?true:false;//牌大或者牌一样并且花色大
            }
        },
        /**
         * 额度换算
         */
        chipsConvert(amount){
            let arr=[];//最终转换成的额度
            let amountArr = AMOUTN_ARR.slice(0,AMOUTN_ARR.length-1);//取除了梭哈之外的额度
            for (let i = amountArr.length-1; i >= 0; i--) {
                if(amount>=amountArr[i]){
                    let num=Math.floor(amount/amountArr[i]);//获取要换算的额度最多能换到多少个当前遍历到的额度
                    for (let j = 0; j < num; j++) {
                        arr.push(amountArr[i]);
                    }
                    amount-=num*amountArr[i];
                }
            }
            return arr;
        },
        /**
         * 显示全部路单
         * @param {PEARL_TYPE} pearlType 台面id
         */
        showMorePearl(pearlType){
            this.pearlMoreType=pearlType;
            this.$nextTick(()=>{
                this.drawMorePearl(pearlType);
                this.isShowPearlMoreLayer=false;
            })
        },
        /**
         * 绘制全部历史路单
         */
        drawMorePearl(pearlType){
            let obj;
            let elem=document.getElementById("fullPearl");//获取画布元素
            if(elem){
                let style=getComputedStyle(elem);//获取画布样式
                let height=style.height.replace('px','');//获取画布高度
                let width=getComputedStyle(elem.parentElement).width.replace('px','');//获取一版画布的宽度
                let cellHeight=height/6;//单元格高度
                let dataColumn=0;//获取数据需要的列数
                let canvasColumn=Math.round(width / cellHeight);//获取一版画布可以绘制多少列
                let arr;
                if(pearlType==PEARL_TYPE.big_text){
                    dataColumn=Math.ceil(this.pearlArr.flat(Infinity).length/6);
                }else if(pearlType==PEARL_TYPE.big_hollow||pearlType==PEARL_TYPE.small_hollow||pearlType==PEARL_TYPE.small_solid||pearlType==PEARL_TYPE.bevel){
                    arr=this.$root.setPearlData(this.roomInfo.game,this.pearlArr,Infinity,false);//第一次调用setPearlData是为了去掉和，此时并无法确定要保留多少列
                    pearlType!=PEARL_TYPE.big_hollow&&(arr=this.$root.convertToSmallPearl(arr,pearlType));
                    //循环获取拐弯后真实需要占用的列数
                    var maxPoint = [0, 0, 0, 0, 0, 0];//保存每一行露珠达到的最大x坐标点
                    var lastPoint = 0;
                    for (var i = 0; i <arr.length; i++) {//倒序遍历处理后的数组
                        for (var j = 0, currentRow = 0; j < arr[i].length; j++) {
                            if (currentRow == 6 || (i+1) <= maxPoint[currentRow]) {//已经到达最后一行或者当前要画的x坐标小于或等于当前要画行的最大坐标，即当前要画的位置已有露珠
                                if (!(currentRow == 6 && lastPoint < (i+1) - (arr[i].length - 6))) {//如果非(当前已到达第6行并且向左拐不与当前行最大点重叠)，则向右拐
                                    maxPoint[currentRow - 1] = (i+1) + (j - (currentRow-1));//更新最大坐标点为当前个数-当前所在行+当前列=要画的露珠列
                                }
                            } else {//否则向下画
                                currentRow == 5 && (lastPoint = maxPoint[currentRow] == 0 ? 0 : maxPoint[currentRow]);//如果已是最后一行，则保存最大坐标点，用于左拐判断
                                maxPoint[currentRow] = i+1;//更新最大坐标点
                                currentRow++;//累加当前列露珠到达的行数
                            }
                        }
                    }
                    dataColumn=Math.max.apply(null,maxPoint);
                }else if(pearlType==PEARL_TYPE.big_three){
                    dataColumn=Math.ceil(this.pearlArr.flat(Infinity).length/3);
                }
                if(dataColumn<canvasColumn){//如果数据需要的列数比一版画布的列数少，说明一版够用
                    this.$root.setCanvasSize(elem);//设置画布大小
                    elem.style.left="";
                    obj = this.$root.drawCanvasTable(elem,6,false);
                }else{//一版不够展示
                    //加长画布
                    elem.width=dataColumn*cellHeight*RATIO;
                    elem.height=height*RATIO;
                    elem.style.width=dataColumn*cellHeight+"px";
                    // elem.style.height=height+"px";
                    elem.style.left="";
                    elem.style.left=style.left;
                    obj = this.$root.drawCanvasTable(elem,6,false);
                }
                if(pearlType==PEARL_TYPE.big_text||pearlType==PEARL_TYPE.big_three){
                    this.$root.drawOrderPearl(obj,this.pearlArr,pearlType);
                }else if(pearlType==PEARL_TYPE.big_hollow){
                    this.$root.drawPearl(obj,arr,PEARL_TYPE.big_hollow,GAME_ID.bac);
                }else if(pearlType==PEARL_TYPE.small_hollow||pearlType==PEARL_TYPE.small_solid||pearlType==PEARL_TYPE.bevel){
                    this.$root.drawPearl(obj,
                        this.$root.setPearlData(this.roomInfo.game,arr,Infinity,false),//第二次调用setPearlData是为了保留多少列
                        pearlType,GAME_ID.bac,true);
                }
            }
        },
        /**
         * 移动路单
         */
        movePearlMore(type){
            let elem=document.getElementById("fullPearl");//获取画布元素
            let style=getComputedStyle(elem);//获取画布样式
            let left=Number(style.left.replace('px',''));//获取左边距
            let width=Number(getComputedStyle(elem.parentElement).width.replace('px',''));//获取一版画布的宽度
            let fullWidth=Number(style.width.replace('px',''));//获取整个画布宽度
            type==-1&&(elem.style.left=(Math.abs(left)<=width?0:left+width)+"px");//左边剩下的距离只有不够一版画布的宽度则全部显示，大于一版则只显示一版
            //右边剩下的距离(即画布总宽度-左边剩下的距离-一版画布的宽度)只有不够一版的宽度，则左边距设为总宽度-一版宽度,否则说明剩余超出一版宽度则左边距设为左边距-一版宽度
            type==1&&(elem.style.left=(fullWidth-Math.abs(left)-width<=width?-(fullWidth-width):left-width)+"px");
        },
        /**
         * 自动额度选择
         */
        autoAmount(){
            if(this.userAmountList.length==0){//没有选择过额度
                let min=this.limitred.z.split('-')[0];//最低额度
                let max=this.limitred.z.split('-')[1];//最高额度
                // min==0?10:min;//最小额度默认值
                // max==0?1000:max;//最大额度默认值
                // let minLen=Math.abs(min).toString().length;//最小值的位数
                // let maxLen=Math.abs(max).toString().length;//最大值的位数
                // let maxFirst=parseInt(Math.abs(max).toString()[0],10);//最大额度的首位
                let arr=[];
                // arr[0][0]=Math.pow(10,minLen-1);//设置第一个额度(最低额度的基数值，即两位数取10，三位数取100)
                // arr[2][0]=(maxFirst>2?1:5)*(Math.pow(10,maxFirst>2?maxLen-1:maxLen-2));//设置第五个额度(2和2以下取位数减一的5字头，即1000或2000取500，3000取1000)
                if(min==20&&max==1000){
                    arr=[[10,50],[100,200],[500]];
                }else if((min==50&&max==10000)||(min==200&&max==10000)||(min==200&&max==20000)||(min==100&&max==20000)){
                    arr=[[50,100],[500,1000],[5000]];
                }else if((min==300&&max==30000)||(min==300&&max==50000)){
                    arr=[[100,500],[1000,5000],[10000]];
                }else if((min==500&&max==80000)||(min==800&&max==100000)||(min==2000&&max==200000)||(min==3000&&max==300000)){
                    arr=[[100,1000],[5000,10000],[20000]];
                }else{
                    arr=[[10,100],[200,500],[1000]];
                }
                // if (max<=1000) {
                //     arr= [[10,20],[50,100],[200]];
                // }else if ((max>1000&&max<=2000)||(max>2000&&max<=5000)) {
                //     arr= [[10,50],[100,500],[1000]];
                // }else if(max>5000&&max<=10000){
                //     arr= [[10,100],[500,1000],[2000]];
                // }else if(max>10000&&max<=20000){
                //     arr= [[10,100],[500,1000],[5000]];
                // }else if(max>20000&&max<=100000){
                //     arr= [[10,100],[1000,5000],[10000]];
                // }else {
                //     arr= [[10,50],[100,500],[1000]];
                // }
                this.$store.commit({
                    type:MUTATION_TYPE.setCurrAmountList,
                    currAmountList:arr
                })
            }
        },
        /**
         * 设置印记类型
         */
        setMarkType(isReset){
            if(isReset){//重置进度
                if(this.userInfo.mark==0){
                    useLayer({str:this.$t("room.unReset")});
                    return;
                }
                useLayer({type:LAYER_TYPE.confirm,str:this.$t("room.resetConfirm"),btn:[this.$t("room.clear"),this.$t("room.forget")],yesFn:()=>{
                    this.$emit("ws-send",COMMAND.all_setruletype,RULE_TYPE.mark,0,this.userInfo.id,this.userInfo.guid);
                }})
            }else{
                if(this.currRuleType>this.userInfo.markType&&this.userInfo.markType!=0){//当前希望升级
                    useLayer({type:LAYER_TYPE.confirm,str:this.$t("room.upgradeConfirm"),btn:[this.$t("room.upgrade"),this.$t("room.forget")],yesFn:()=>{
                        this.$emit("ws-send",COMMAND.all_setruletype,RULE_TYPE.mark,this.currRuleType,this.userInfo.id,this.userInfo.guid);
                    }})
                }else if(this.currRuleType<this.userInfo.markType){//当前希望降级
                    if(this.userInfo.mark==0){//还没有印记随便变更难度
                        this.$emit("ws-send",COMMAND.all_setruletype,RULE_TYPE.mark,this.currRuleType,this.userInfo.id,this.userInfo.guid);
                    }else{//已有印记
                        useLayer({str:this.$t("room.unDegrade")});
                    }
                }
            }
            
        },
        videoReady(videoId){
            this.readyVideoIdArr.push(videoId);
        },
    },
    watch: {
        /**
         * 监听路单数据变化
         */
        pearlArr:{
            handler(newVal){
                this.drawPearl(newVal);
                this.drawMorePearl(this.pearlMoreType);
            },
            deep:true//深度监听
        },
        /**
         * 监听视频线路id改变
         */
        currVideoLine(newVal,oldVal){
            if(newVal!=""){
                if(newVal&&this.lastVideoLine!=newVal){
                    //获取台面视频
                    this.$emit("ws-send",COMMAND.all_getvideo,this.roomInfo.id,newVal,this.userInfo.id,this.userInfo.guid);
                    this.lastVideoLine=newVal;
                }
            }else{
                this.videoList=null;
            }
        },
        /**
         * 监听将要提交的额度变化
         */
        submiting:{
            handler(){
                if(this.getAmountCount("submiting")<=0||this.roomInfo.countdown<=0){
                    this.canClear=false;
                    this.canConfirm=false;
                }else{
                    this.canClear=true;
                    this.canConfirm=true;
                }
            },
            deep:true
        },
        /**
         * 监听已提交过的额度变化
         */
        submited:{
            handler(){
                if(this.getAmountCount("submited",this.currRebate)<=0||this.roomInfo.countdown<=0){
                    this.canCancel=false;
                }else{
                    this.canCancel=true;
                }
            },
            deep:true
        },
        /**
         * 监听路单模式改变
         */
        pearlModel(){
            this.$nextTick(()=>{
                this.drawPearl(this.pearlArr);
                this.drawMorePearl(this.pearlMoreType);
            })
        },
        /**
         * 监听guid改变（断线重连）
         */
        "userInfo.guid"(newVal,oldVal){
            if(newVal!=oldVal&&newVal!=""&&oldVal!=""){
                this.init();
            }
        },
        "roomInfo.countdown"(newVal){
            if(newVal==0){
                this.canCancel=false;
                this.canConfirm=false;
            }
        },
        readyVideoIdArr(val){
            console.log(val+"------------------------------------");
        },
        authorizeObj:{
            handler(newVal){
                window.authorize=newVal;
                if(newVal.error){
                    document.body.innerText="window.authorize:"+JSON.stringify(newVal);
                }
            },
            deep:true
        }
    },
};
</script>